export const GET_ITEM_ENDPOINT = `/api/items`;
export const CREATE_ITEM_ENDPOINT = `/api/items/add/`;
export const DELETE_ITEM_ENDPOINT = `/api/items/delete`;
export const EDIT_ITEM_ENDPOINT = `/api/items/edit`;
export const CUTTING_LIST_ENDPOINT = `/api/cutting`;
export const GET_CUTTING_TABLE_ENDPOINT = `/api/cutting/product/create`;
export const STORE_CUTTING_ENDPOINT = `/api/cutting/add`;
export const STORE_CUTTING_PRODUCT_ENDPOINT = `/api/cutting/product/store`;
export const GET_CUTTING_PRODUCT_ENDPOINT = `/api/cutting/edit-product`;
export const EDIT_CUTTING_PRODUCT_ENDPOINT = `/api/cutting/product/edit`;
export const STORE_CUTTING_ITEM_ENDPOINT = `/api/cutting/itemAdd`;
export const GET_CUTTING_ENDPOINT = `/api/cutting/item/create`;
export const STORE_SHIPMENT_ENDPOINT = `/api/shipping/add`;
export const GET_SHIPMENT_ENDPOINT = `/api/shipping/create/by-date`;
export const GET_FOLDING_ENDPOINT = `/api/folding/create/by-date`;
export const STORE_PACKING_ENDPOINT = `/api/packing/add`;
export const GET_PACKING_ENDPOINT = `/api/packing/create/by-date`;
export const GET_STYLE_LIST_ENDPOINT = `/api/styles`;
export const GET_DASHBOARD_ENDPOINT = `/api/dashboard`;
export const GET_CATEGORY_ENDPOINT = `/api/itemscategories`;
export const CREATE_CATEGORY_ENDPOINT = `/api/itemscategories/add`;
export const DELETE_CATEGORY_ENDPOINT = `/api/itemscategories/delete`;
export const EDIT_CATEGORY_ENDPOINT = `/api/itemscategories/edit`;
export const getItemCategoryAssignedUnitsUrl = (categoryId) =>
  `/api/itemscategories/assigned-units/${categoryId}`;
export const postItemCategoryAssignUnitsUrl = (categoryId) =>
  `/api/itemscategories/assign-units/${categoryId}`;
export const GET_USERS_ENDPOINT = `/api/users`;
export const GET_TNA_TEMPLATE_RESPONSIBLE_USERS_ENDPOINT = `/api/users/tna-template-responsible`;
export const GET_USERS_LIST_ENDPOINT = `/api/usersList`;
export const GET_ALL_USERS_ENDPOINT = `/api/users-all`;
export const CREATE_USER_ENDPOINT = `/api/users/store`;
export const DELETE_USER_ENDPOINT = `/api/users/delete`;
export const EDIT_USER_ENDPOINT = `/api/users/edit`;
export const GET_USERS_ROLE_ENDPOINT = `/api/roles`;
export const CREATE_USER_ROLE_ENDPOINT = `/api/roles/store`;
export const DELETE_USER_ROLE_ENDPOINT = `/api/roles/delete`;
export const EDIT_USER_ROLE_ENDPOINT = `/api/roles/edit`;
export const GET_USER_PERMISSIONS = `/api/permissions`;
export const GET_SEWING_LINE_ENDPOINT = `/api/sewing_lines`;
export const CREATE_SEWING_LINE_ENDPOINT = `/api/sewing_lines/add`;
export const DELETE_SEWING_LINE_ENDPOINT = `/api/sewing_lines/delete`;
export const EDIT_SEWING_LINE_ENDPOINT = `/api/sewing_lines/edit`;
export const CREATE_BRANCH_ENDPOINT = `/api/branches/add`;
export const GET_BANK_ENDPOINT = `/api/banks`;
export const CREATE_BANK_ENDPOINT = `/api/banks/add`;
export const DELETE_BANK_ENDPOINT = `/api/banks/delete`;
export const EDIT_BANK_ENDPOINT = `/api/banks/edit`;
export const GET_BOM_ENDPOINT = `api/bill_of_material`;
export const CREATE_BOM_ENDPOINT = `/api/bill_of_material/add`;
export const DELETE_BOM_ENDPOINT = `/api/bill_of_material/delete`;
export const EDIT_BOM_ENDPOINT = `/api/bill_of_material/edit`;
export const GET_BOM_DETAILS_ENDPOINT = `/api/bill_of_material/edit`;
export const GET_BOM_ENDPOINT_LIST = `/api/bill_of_material`;
export const UPDATE_BOM = `/api/bill_of_material/edit/`;
export const GET_INVENTORY_ENDPOINT = `api/inventory`;
export const CREATE_INVENTORY_ENDPOINT = `/api/inventory/add`;
export const DELETE_INVENTORY_ENDPOINT = `/api/inventory/delete`;
export const EDIT_INVENTORY_ENDPOINT = `/api/inventory/edit`;
export const GET_ORGANIZATION_ENDPOINT = `/api/organizations`;
export const CREATE_ORGANIZATION_ENDPOINT = `/api/organizations/add`;
export const DELETE_ORGANIZATION_ENDPOINT = `/api/organizations/delete`;
export const EDIT_ORGANIZATION_ENDPOINT = `/api/organizations/edit`;
export const GET_BRAND_ENDPOINT = `/api/brands`;
export const CREATE_BRAND_ENDPOINT = `/api/brands/add`;
export const DELETE_BRAND_ENDPOINT = `/api/brands/delete`;
export const EDIT_BRAND_ENDPOINT = `/api/brands/edit`;
export const GET_BUYER_ENDPOINT = `/api/buyers`;
export const CREATE_BUYER_ENDPOINT = `/api/buyers/add`;
export const DELETE_BUYER_ENDPOINT = `/api/buyers/delete`;
export const EDIT_BUYER_ENDPOINT = `/api/buyers/edit`;
export const GET_COMPETITOR_ENDPOINT = `/api/competitors`;
export const CREATE_COMPETITOR_ENDPOINT = `/api/competitors/add`;
export const DELETE_COMPETITOR_ENDPOINT = `/api/competitors/delete`;
export const EDIT_COMPETITOR_ENDPOINT = `/api/competitors/edit`;
export const GET_SUPPLIER_ENDPOINT = `/api/suppliers`;
export const CREATE_SUPPLIER_ENDPOINT = `/api/suppliers/add`;
export const DELETE_SUPPLIER_ENDPOINT = `/api/suppliers/delete`;
export const EDIT_SUPPLIER_ENDPOINT = `/api/suppliers/edit`;
export const GET_BUYING_OFFICE_ENDPOINT = `/api/buying_office`;
export const CREATE_BUYING_OFFICE_ENDPOINT = `/api/buying_office/add`;
export const DELETE_BUYING_OFFICE_ENDPOINT = `/api/buying_office/delete`;
export const EDIT_BUYING_OFFICE_ENDPOINT = `/api/buying_office/edit`;
export const STYLE_MERCHANDISING_LIST = `/api/styles`;
export const STYLE_MERCHANDISING_ADD = `/api/styles/add`;
export const STYLE_MERCHANDISING_UPDATE = `/api/styles/edit/`;
export const SALES_CONTRACT_360_LIST = `/api/sales_contact`;
export const SALES_CONTRACT_LIST = `/api/sales_contract`;
export const ALL_SALES_CONTRACT_LIST = `/api/accounting/all-sales-contract`;
export const ALL_SALES_CONTRACT_LIST_UPDATED = `/api/accounting/import-pi/all-sales_contracts`;
export const COMMERCIAL_SALES_CONTRACT_LIST = `/api/accounting/commercial-sales-contract`;
export const SALES_CONTRACT_ADD = `/api/sales_contract/add`;
export const ORDER_DETAILS_LIST = `/api/sales_contract`;
export const PURCHAS_ORDER_LIST = `/api/purchase_orders`;
export const PO_ADD = `/api/purchase_orders/add`;
export const GET_BANK_ACCOUNT_ENDPOINT = `/api/bank_accounts`;
export const CREATE_BANK_ACCOUNT_ENDPOINT = `/api/bank_accounts/add`;
export const DELETE_BANK_ACCOUNT_ENDPOINT = `/api/bank_accounts/delete`;
export const EDIT_BANK_ACCOUNT_ENDPOINT = `/api/bank_accounts/edit`;
export const SALES_CONTRACT_STYLE_DETAILS_LIST = `/api/styles/view`;
export const GET_MERCHANDISER_ENDPOINT = `/api/merchandisers`;
export const DELETE_MERCHANDISER_ENDPOINT = `/api/merchandisers/delete/`;
export const EDIT_MERCHANDISER_ENDPOINT = `/api/merchandisers/edit/`;
export const CREATE_MERCHANDISER_ENDPOINT = `/api/merchandisers/add/`;
export const GET_SALES_CONTRACT_ENDPOINT = `/api/sales_contract`;
export const DELETE_SALES_CONTRACT_ENDPOINT = `/api/sales_contract/delete`;
export const EDIT_SALES_CONTRACT_ENDPOINT = `/api/sales_contract/edit`;
export const CREATE_SALES_CONTRACT_ENDPOINT = `/api/sales_contract/add`;
export const GET_COLORS = `/api/colors`;
export const ADD_COLORS = `/api/colors/add`;
export const ADD_SIZE = `/api/sizes/add`;
export const GET_SIZES = `/api/sizes`;
export const GET_ITEM_CATEGORIES = `/api/itemscategories`;
export const GET_ITEM_CATEGORIES_API = `/api/itemscategories/api`;
export const GET_ALL_UNITS = `/api/units`;
export const SALES_ADD_DOC = `/api/sales_contract/add-document`;
export const STYLE_ADD_DOC = `/api/styles/add-document`;
export const SALES_CONTRACT_UPDATE = `/api/sales_contract/edit/`;
export const PO_UPDATE = `/api/purchase_orders/edit/`;
export const IMPORT_PI_ADD_DOC = `/api/accounting/import-pi/add-document`;
export const IMPORT_B2BLC_ADD_DOC = `/api/accounting/import-b2blc/add-document`;
export const OT_SIGNAL_SECTION_WITH_OT_SIGNALS_AND_LINE_ID = `/api/ot-signal-sections-with-ot-signals-and-line-id`;
export const DECISION_POINT_AVAILABILIY = `/api/decisionPointAvailability`;
export const GET_SALES_CONTRACT_DETAILS_ENDPOINT = (salesContractId) => {
  if (salesContractId) {
    return `/api/sales_contract/${salesContractId}/view`;
  } else {
    return null;
  }
};
export const ASSIGNMENT_LIST_ENDPOINT = `/api/assignment/`;
export const SEWING_LIST = `/api/sewing`;
export const GET_ASSIGNMENT_SUMMARY = `/api/assignment/summary-generate`;
export const GET_LINE_ASSIGNMENT = `/api/assignment/line-assignment`;
export const ADD_ASSIGNMENT = `/api/assignment/add`;
export const ADD_UNIT = `/api/units/add`;
export const SWING_ADD_VIEW = `/api/sewing/create/by-subStyle`;
export const SWING_ADD = `/api/sewing/add`;
export const PREVIOUS_STYLE_LIST = `/api/bill_of_material/previous-styles`;
export const PO_WISE_COLOR = `/api/purchase_orders/colors`;
// User List
export const USER_LIST = `/api/users`;
export const PLANNING_USER_LIST = `/api/get_planning_user_list`;
/// Accounting
export const FORWARDER_LIST = `/api/accounting/forwarder`;
export const FORWARDER_ADD = `/api/accounting/forwarder/add`;
export const IOU_LIST = `/api/accounting/ious`;
export const IOU_ADD = `/api/accounting/iou/add`;
export const IOU_EDIT = `/api/accounting/iou/edit`;
export const SALES_CONTRACT_COMMERCIAL_LIST = `/api/accounting/sales-contract-commercials`;
export const SALES_CONTRACT_COMMERCIAL_ADD = `/api/accounting/sales-contract-commercial/add`;
export const SALES_CONTRACT_COMMERCIAL_ADD_DELETE_REASON = `/api/accounting/sales-contract-commercial/add-delete-reason`;
export const SALES_CONTRACT_COMMERCIAL_EDIT = `/api/accounting/sales-contract-commercial/edit`;
export const SALES_CONTRACT_COMMERCIAL_DOC = `/api/accounting/sales-contract-commercial/add-document`;
export const SALES_CONTRACT_WITHOUT_COMMERCIAL_LIST = `/api/accounting/sales-contract-without-commercials`;
export const ALL_SALES_CONTRACT_COMMERCIAL_LIST = `/api/accounting/all-sales-contract-commercials`;
export const UD_NUMBERS_LIST = `/api/accounting/ud_numbers`;
export const IMPORT_COVER_NOT = `/api/accounting/cover-note`;
export const IMPORT_COVER_NOT_ADD = `/api/accounting/cover-note/add`;
export const IMPORT_B2B_LC_LIST = `/api/accounting/import-b2blcs`;
export const IMPORT_B2B_LC_ADD = `/api/accounting/import-b2blc/add`;
export const IMPORT_B2B_LC_EDIT = `/api/accounting/import-b2blc/edit`;
export const IMPORT_PI_LIST = `/api/accounting/import-pis`;
export const IMPORT_PI_ADD = `/api/accounting/import-pi/add`;
export const IMPORT_PI_EDIT = `/api/accounting/import-pi/edit`;
export const IMPORT_PI_VIEW = `/api/accounting/import-pi/view`;
export const IMPORT_PI_UPDATE = `/api/accounting/import-pi/update`;
export const IMPORT_PI_SALES_CONTRACT_SUMMARY = `/api/accounting/import-pi/sales-contract-summary`;
export const IMPORT_DETAIL_LIST = `/api/accounting/import-details`;
export const IMPORT_DETAIL_CNF_LIST = `/api/accounting/import-details-cnf`;
export const IMPORT_DETAIL_ADD = `/api/accounting/import-detail/add`;
export const IMPORT_DETAIL_EDIT = `/api/accounting/import-detail/edit`;
export const IMPORT_DETAIL_ADD_DOC = `/api/accounting/import-detail/add-document`;
export const GET_LC_ACCEPTANCE_DETAIL = `/api/accounting/import-detail/check-acceptance-details`;
export const IMPORT_DETAIL_ALL_SUPPLIERS = `/api/accounting/get-all-suppliers`;
export const IMPORT_DETAIL_COURIER_NAMES = `/api/accounting/import-detail/courier-names`;
export const IMPORT_DETAIL_COURIER_NAMES_ADD = `/api/accounting/import-detail/courier-names`;
export const IMPORT_ACCEPTANCE_DETAIL_LIST = `/api/accounting/import-acceptance-details`;
export const IMPORT_ACCEPTANCE_DETAIL_ADD = `/api/accounting/import-acceptance-detail/add`;
export const IMPORT_ACCEPTANCE_DETAIL_EDIT = `/api/accounting/import-acceptance-detail/edit`;
export const SECURITY_BOLT_SEAL_LIST = `/api/accounting/security-bolt-seal`;
export const SECURITY_BOLT_SEAL_ADD = `/api/accounting/security-bolt-seal/add`;
export const SECURITY_BOLT_SEAL_EDIT = `/api/accounting/security-bolt-seal/edit`;
export const SECURITY_BOLT_SEAL_BUYERS = `/api/accounting/buyers`;
export const SECURITY_BOLT_SEAL_DELETE = `/api/accounting/security-bolt-seal/delete`;
export const SHIPMENT_HANDOVER_LIST = `/api/accounting/shipment-handover`;
export const SHIPMENT_HANDOVER_ADD = `/api/accounting/shipment-handover/add`;
export const SHIPMENT_HANDOVER_EDIT = `/api/accounting/shipment-handover/edit`;
export const SHIPMENT_HANDOVER_BUYERS = `/api/accounting/buyers`;
export const SHIPMENT_HANDOVER_DELETE = `/api/accounting/shipment-handover/delete`;
export const GET_ASSIGN_SUMMARY_ENDPOINT = `/api/track-items/create`;
export const ASSIGN_TRACK_ENDPOINT = `/api/track-items/store`;
export const WAREHOUSE_LIST_ENDPOINT = `/api/warehouses`;
export const WAREHOUSE_ADD_ENDPOINT = `/api/warehouses/add`;
export const WAREHOUSE_EDIT_ENDPOINT = `/api/warehouses/edit`;
export const WAREHOUSE_DELETE_ENDPOINT = `/api/warehouses/delete`;
export const RACK_LIST_ENDPOINT = `/api/racks`;
export const RACK_ADD_ENDPOINT = `/api/racks/add`;
export const RACK_EDIT_ENDPOINT = `/api/racks/edit`;
export const RACK_DELETE_ENDPOINT = `/api/racks/delete`;
export const BIN_LIST_ENDPOINT = `/api/bins`;
export const BIN_ADD_ENDPOINT = `/api/bins/add`;
export const BIN_EDIT_ENDPOINT = `/api/bins/edit`;
export const BIN_DELETE_ENDPOINT = `/api/bins/delete`;
export const UNIT_LIST_ENDPOINT = `/api/units`;
export const UNIT_ADD_ENDPOINT = `/api/units/add`;
export const UNIT_EDIT_ENDPOINT = `/api/units/edit`;
export const UNIT_DELETE_ENDPOINT = `/api/units/delete`;
export const SUPPLIER_LIST_ENDPOINT = `/api/suppliers`;
export const SUPPLIER_ADD_ENDPOINT = `/api/suppliers/add`;
export const SUPPLIER_EDIT_ENDPOINT = `/api/suppliers/edit`;
export const SUPPLIER_DELETE_ENDPOINT = `/api/suppliers/delete`;
export const COLOR_LIST_ENDPOINT = `/api/colors`;
export const COLOR_ADD_ENDPOINT = `/api/colors/add`;
export const COLOR_EDIT_ENDPOINT = `/api/colors/edit`;
export const COLOR_DELETE_ENDPOINT = `/api/colors/delete`;
export const SIZE_LIST_ENDPOINT = `/api/sizes`;
export const SIZE_ADD_ENDPOINT = `/api/sizes/add`;
export const SIZE_EDIT_ENDPOINT = `/api/sizes/edit`;
export const SIZE_DELETE_ENDPOINT = `/api/sizes/delete`;
export const EXPORT_BOM_ENDPOINT = `/api/bill_of_material/export`;
export const TRACK_ITEM_REMOVE_ENDPOINT = `/api/track-items/delete`;
export const FIND_RACK_ENDPOINT = `/api/racks/show`;
export const FIND_BIN_ENDPOINT = `/api/bins/show`;
export const FINISH_GOOD_ENDPOINT = `/api/finish_garment`;
export const FINISH_GOOD_SELL_ENDPOINT = `/api/finish_garment/sell-add`;
export const FINISH_GOOD_SAMPLE_ENDPOINT = `/api/finish_garment/sample-add`;
export const FINISH_GOOD_GIFT_ENDPOINT = `/api/finish_garment/gift-add`;
export const REMOVE_PO_ROW = `/api/purchase_orders/remove-row`;
export const REMOVE_SIZE_COLUMN = `/api/purchase_orders/remove-column`;
export const UNIT_CONVERTION_ADD_ENDPOINT = `/api/conversions/add`;
export const UNIT_CONVERTION_LIST_ENDPOINT = `/api/conversions`;
export const UNIT_CONVERTION_EDIT_ENDPOINT = `/api/conversions/edit`;
export const UNIT_CONVERTION_DELETE_ENDPOINT = `/api/conversions/delete`;
export const GET_IMPORT_PI_BUDGET_ENDPOINT = `/api/accounting/get-importpi-budget`;
export const GET_PI_NUMBERS_LIST = `/api/accounting/pi-numbers-list-salescontract`;
export const EXPORT_DETAILS_ADD = `/api/accounting/export-details/add`;
export const GET_EXPORT_DETAILS_LIST = `/api/accounting/export-details`;
export const EXPORT_DETAIL_CNF_LIST = `/api/accounting/export-details-cnf`;
export const GET_EXPORT_DETAILS_SUMMARY = `/api/accounting/export-details/summary`;
export const DELETE_EXPORT_DETAILS = `/api/accounting/export-details/delete`;
export const EDIT_EXPORT_DETAILS = `/api/accounting/export-details/edit`;
export const ADD_EXPORT_GOODS_DESCRIPTION = `/api/accounting/export-details/add-goods-description`;
export const INVOICE_SUBMISSION_REALIZATION_VALUE = `/api/accounting/export-details/submission-realization-value`;
export const EXPORT_DETAIL_GOODS_DESCRIPTIONS_LIST = `/api/accounting/export-detail-goods-descriptions`;
export const SUBMISSION_REALIZATION_ADD = `/api/accounting/submission-realizations/add`;
export const GET_SUBMISSION_REALIZATION_LIST = `/api/accounting/submission-realizations`;
export const DELETE_SUBMISSION_REALIZATION = `/api/accounting/submission-realizations/delete`;
export const EDIT_SELECTED_SUBMISSION_REALIZATION = `/api/accounting/submission-realizations/edit`;
export const SUBMISSION_REALIZATION_DOC = `/api/accounting/submission-realizations/add-document`;
export const SUBMISSION_REALIZATION_INVOICE_DOCUMENT = `/api/accounting/submission-realizations/add-invoice-document`;
export const SUBMISSION_REALIZATION_INVOICE_SEARCH = `/api/accounting/submission-realizations/searchInvoice`;
export const SUBMISSION_REALIZATION_SALES_CONTRACT_LIST = `/api/accounting/submission-realizations/all-sales-contract`;
export const GET_CUSTOMS_CLEARANCE_LIST = `/api/accounting/customs-clearances`;
export const ADD_CUSTOMS_CLEARANCE = `/api/accounting/customs-clearances/add`;
export const VIEW_CUSTOMS_CLEARANCE = `/api/accounting/customs-clearances/edit`;
export const DELETE_CUSTOMS_CLEARANCE = `/api/accounting/customs-clearances/delete`;
export const NOTING_ASSESSMENT_DOC = `/api/accounting/noting-assessments/add-document`;
export const GET_B2BLCS_FOR_NOTING = `/api/accounting/b2blcs-for-noting`;
export const GET_INVOICES_FOR_NOTING = `/api/accounting/get-shipment-invoices`;
export const GET_B2B_LC_LIST = `/api/accounting/get-b2blc`;
export const GET_PO_INFO = `/api/findPurchaseOrderInfo`;
export const GOODS_DELIVERY_ADD = `/api/accounting/goods-delivery/add`;
export const GET_GOODS_DELIVERY_LIST = `/api/accounting/goods-delivery`;
export const DELETE_GOODS_DELIVERY = `/api/accounting/goods-delivery/delete`;
export const EDIT_GOODS_DELIVERY = `/api/accounting/goods-delivery/edit`;

// Import Shipment for Multiple Vehicle endpoints
export const IMPORT_VEHICLE_ASSIGNMENT = `/api/accounting/import-vehicle-assignment`;

export const GET_FABRIC_RECONCILIATION = `/api/report/all_fabric_reconciliations`;
export const EXPORT_FABRIC_RECONCILIATION = `/api/report/export_fabric_reconciliation_report`;
export const EXPORT_SWING_VS_FOLDING = `/api/report/export_sewing_and_folding_report`;
export const EXPORT_OPERATOR_ABSINTHIUM_REPORT = `/api/report/export_operator_absinthium_report`;
export const VIEW_ABSENTEEISM_INFORMED_REASON_REPORT = `/api/report/view_absenteeism_informed_reason_report`;
export const EXPORT_ABSENTEEISM_INFORMED_REASON_REPORT = `/api/report/export_absenteeism_informed_reason_report`;
export const EXPORT_CONTRACT_PO_LIST = `/api/report/export_active_po_list`;
export const DELETE_FABRIC_RECONCILIATION = `/api/report/delete_fabric_reconciliation_report`;
export const GET_PRODUCTION_TRACKING = `/api/report/all_production_tracks`;
export const EXPORT_PRODUCTION_TRACKING = `/api/report/export_production_tracking_report`;
export const DELETE_PRODUCTION_TRACKING = `/api/report/delete_production_tracking_report`;
export const GET_PRODUCTION_DETAILS = `/api/report/all_production_details`;
export const EXPORT_PRODUCTION_DETAILS = `/api/report/export_production_details_report`;
export const DELETE_PRODUCTION_DETAILS = `/api/report/delete_production_details_report`;
export const GET_COST_SHEET = `/api/report/all_cost_sheet`;
export const EXPORT_COST_SHEET = `/api/report/export_cost_sheet_report`;
export const DELETE_COST_SHEET = `/api/report/delete_cost_sheet_report`;
export const GET_EXPORT_DETAILS_INVOICE = `/api/accounting/export-detail-invoices`;
export const UPLOAD_SIZE = `/api/upload-size`;
export const BACKUP_FILES_LIST = `/api/backupList`;
export const SAMPLE_FILES_LIST = `/api/allTemplates`;
export const RAW_MATERIAL_ADD = `/api/raw_material_inventory/add`;
export const RAW_MATERIAL_ITEM_BY_TIME = `/api/raw_material_inventory/findItem`;
export const RAW_MATERIAL_UPDATE = `/api/raw_material_inventory/edit`;
export const RAW_MATERIAL_DELETE = (id) => `/api/raw_material_inventory/delete/${id}`;
export const RAW_MATERIAL_INVENTORY_LIST = `/api/raw_material_inventory/list`;
export const RAW_MATERIAL_INVENTORY_EDIT = (id) => `/api/raw_material_inventory/${id}/edit`;
export const GET_INVENTORY_DETAILS = `/api/report/all_inventory_details`;
export const EXPORT_INVENTORY_DETAILS = `/api/report/export_inventory_details_report`;
export const DELETE_INVENTORY_DETAILS = `/api/report/delete_inventory_details_report`;
export const PURCHAS_ORDER_LIST_NEW = `/api/po_wise_purchase_orders`;
export const PO_ADD_NEW = `/api/po_wise_purchase_orders/add`;
export const PO_UPDATE_NEW = `/api/po_wise_purchase_orders/edit/`;
export const PO_WISE_UPDATE_UNIT_PRICE = `/api/po_wise_purchase_orders/update-unit-price`;
export const GET_PO_DETAILS_INFO = `/api/po_wise_purchase_orders/edit_view`;
export const GET_ALL_ACTIVITY_LOGS = `/api/activity-logs`;
export const NOTIFICATIONS_LIST = `/api/notifications`;
export const SEND_PI_NOTIFICATION = `/api/accounting/send-pi-notification`;
export const MARK_ALL_READ_NOTIFICATION = `/api/accounting/mark-notification-read`;
export const COUNT_UNREAD_NOTIFICATION = `/api/accounting/count-unread-notifications`;
export const ACTIVITY_LOG_REPORT_EXPORT = `/api/report/export_activity_logs_report`;
export const ACTIVITY_LOG_REPORT_LIST = `/api/report/all_activity_logs`;
export const DELETE_ACTIVITY_LOG_REPORT = `/api/report/delete_activity_logs_report`;
export const PO_MAP_ENDPOINT = `/api/packing_list/purchase_order_map`;
export const PACKING_STYLE_LIST = `/api/packing_list/style_list`;
export const PACKING_COLOR_LIST = `/api/packing_list/color_list`;
export const PACKING_SIZE_LIST = `/api/packing_list/size_list`;
export const PO_WISE_PACKING_ADD = `/api/packing_list/add`;
export const GET_INVENTORY_MRR_REPORT = `/api/report/all_inventory_mrr`;
export const VIEW_INVENTORY_MRR_REPORT = `/api/report/view_inventory_mrr_report`;
export const EXPORT_INVENTORY_MRR_REPORT = `/api/report/export_inventory_mrr_report`;
export const DELETE_INVENTORY_MRR_REPORT = `/api/report/delete_inventory_mrr_report`;
export const PACKING_LIST = `/api/packing_list`;
export const PO_WISE_PACKING_UPDATE = `/api/packing_list/edit`;
export const PACKING_CONFIRMATION_LIST = `/api/packing/packing_confirmation_list`;
export const EXISTING_PO_MAP_LIST = `/api/packing_list/existing_purchase_order_map`;
export const PACKING_CONFIRM = `/api/packing/packing_confirmation/store`;
export const GET_PACKING_LIST_REPORT = `/api/report/all_packing_list`;
export const EXPORT_PACKING_LIST_REPORT = `/api/report/export_packing_list_report`;
export const DELETE_PACKING_LIST_REPORT = `/api/report/delete_packing_list_report`;
export const OB_MACHINE_ADD = `/api/ob-machine-types/add`;
export const OB_MACHINE_LIST = `/api/ob-machine-types`;
export const OB_MACHINE_DELETE = `/api/ob-machine-types/delete`;
export const OB_MACHINE_EDIT = `/api/ob-machine-types/edit`;
export const OB_SECTION_LIST = `/api/ob-sections`;
export const OB_SECTION_ADD = `/api/ob-sections/add`;
export const OB_SECTION_DELETE = `/api/ob-sections/delete`;
export const OB_SECTION_EDIT = `/api/ob-sections/edit`;
export const OB_SAM_DATA_BANK_LIST = `/api/sam-data-banks`;
export const OB_SAM_DATA_BANK_ADD = `/api/sam-data-banks/add`;
export const OB_SAM_DATA_BANK_DELETE = `/api/sam-data-banks/delete`;
export const OB_SAM_DATA_BANK_EDIT = `/api/sam-data-banks/edit`;
export const PI_REPORT = `/api/report/pi_report`;
export const USER_LOGIN = `/api/login`;
export const OB_STYLE = `/api/obs/styles`;
export const OB_ADD = `/api/obs/add`;
export const OB_LIST = `/api/obs`;
export const OB_DELETE = `/api/obs/delete`;
export const OB_EDIT = `/api/obs/edit`;
export const OB_SHOW = `/api/obs/show`;
export const OB_CLONE = `/api/obs/clone`;
export const EXPORT_SALES_TYPES = `/api/accounting/freight-type`;
export const EXPORT_SALES_TYPES_ADD = `/api/accounting/freight-type/add`;
export const STYLE_WISE_COST_LIST = `/api/accounting/style-wise-cost-estimates`;
export const STYLE_WISE_COST_ADD = `/api/accounting/style-wise-cost-estimate/add`;
export const STYLE_WISE_COST_DELETE = `/api/accounting/style-wise-cost-estimate/delete`;
export const STYLE_WISE_COST_VIEW = `/api/accounting/style-wise-cost-estimate/edit`;
export const STYLE_WISE_COST_EDIT = `/api/accounting/style-wise-cost-estimate`;
export const REST_SALES_CONTRACT = `/api/accounting/rest-sales-contracts`;
export const OB_EXCEL_REPORT = `/api/report/export_xl_ob_report`;
export const OB_PDF_REPORT = `/api/obs/pdf-view/`;
export const BOOKMARK_ADD = `/api/bookmarks/add`;
export const BOOKMARK_LIST = `/api/bookmarks`;
export const BOOKMARK_EDIT = `/api/bookmarks/edit`;
export const BOOKMARK_DELETE = `/api/bookmarks/delete`;
export const BOM = `/api/bill_of_material`;
export const REASONS_LIST = `/api/reasons`;
export const REASONS_ADD = `/api/reasons/add`;
export const REASONS_EDIT = `/api/reasons/edit`;
export const REASONS_DELETE = `/api/reasons/delete`;
export const AMENDMENT_DOC_ADD = `/api/sales_contract/add-amendment-document`;
export const AMEDMENT_ADD = `/api/sales_contract/add/amendment`;
export const EXPORT_LC_REASONS = `/api/accounting/export-lc-reasons`;
export const ADD_LC_REASON = `/api/accounting/sales-contract-commercial/add-lc-reason`;
export const ADD_B2BLC_REMARKS = `/api/accounting/add-b2blc-remarks`;
export const B2BLC_REMARKS_LIST = `/api/accounting/b2blc-remarks`;
export const B2BLC_DOCUMENT_UPLOAD = `/api/accounting/import-b2blc/add-document`;
export const ADVANCED_SEARCH = `/api/advancedSearch`;
export const GLOBAL_SEARCH = `/api/globalSearch`;
export const OB_TEMPLATES = `/api/ob_tamplates`;
export const OB_TEMPLATE_ADD = `/api/ob_tamplates/add`;
export const OB_TEMPLATE_DELETE = `/api/ob_tamplates/delete`;
export const OB_TEMPLATE_EDIT = `/api/ob_tamplates/edit`;
export const ACCEPTANCE_B2BLC_LIST = `/api/accounting/get-all-b2blcs-terms`;
export const ACCEPTANCE_B2BLC_DETAILS = `/api/accounting/import-b2blc/view`;
export const ACCEPTANCE_AVAILABLE_BALANCE = `/api/accounting/get-available-balance`;
export const ACCEPTANCE_INVOICE_NUMBERS = `/api/accounting/invoice-numbers-list`;
export const ACCEPTANCE_REMARKS = `/api/accounting/acceptance-detail-remarks`;
export const ACCEPTANCE_REMARK_ADD = `/api/accounting/add-acceptance-detail-remark`;
export const ACCEPTANCE_FROM_ADD = `/api/accounting/add-acceptance-from`;
export const ACCEPTANCE_FROMS = `/api/accounting/acceptance-froms`;
export const ACCEPTANCE_DELETE = `/api/accounting/import-acceptance-detail/delete`;
export const ACCEPTANCE_DETAILS_VIEW = `/api/accounting/import-acceptance-detail/view`;
export const ACCEPTANCE_DETAIL_DOC = `/api/accounting/import-acceptance-detail/add-document`;
export const INVOICE_BY_SUPPLIER = `/api/accounting/invoices-by-supplier`;
export const CHALLAN_LIST = `/api/challans`;
export const CHALLAN_ADD = `/api/challans/add`;
export const CHALLAN_DOC_ADD = `/api/challans/add-document`;
export const CHALLAN_UPDATE = `/api/challans/edit`;
export const CHALLAN_DELETE = `/api/challans/delete`;
export const LINE_TARGET_LIST = `/api/daily_line_targets`;
export const LINE_TARGET_ADD = `/api/daily_line_targets/add`;
export const LINE_TARGET_UPDATE = `/api/daily_line_targets/edit`;
export const LINE_TARGET_DELETE = `/api/daily_line_targets/delete`;
export const ALL_SUBSTYLES = `/api/sub-styles`;

// Notification slug & settings section
export const NOTIFICATION_SLUGS = `/api/notification-slugs`;
export const NOTIFICATION_SETTINGS = `/api/notification-settings`;
export const GET_ITEMS_CHECK = `/api/bill_of_material/getItems`;
export const IMPORT_DETAIL_DOWNLOAD = `/api/accounting/import-details-download`;
export const GET_INVOICE_IN_HOUSE_DATE = `/api/inventory`;
export const GET_INVOICE_RECONCILIATION_STATUS = `/api/invoice-reconciliation-status`;

export const INVOICE_CHALLAN_MAPPING_RESOURCE = `/api/invoice-mapping`;
export const INVOICE_CHALLAN_MAPPING_EXPORT = `/api/invoice-challan-mapping/export`;
export const INVOICE_CHALLAN_MAPPING_DOC_ADD = `/api/invoice-mappings/add-document`;
export const GET_INVOICE_CHALLAN_MAPPING_MRR_NO = `/api/invoice-challan-mapping/get-mrr-no`;

// Booking Carton (Carton Booking)
export const BOOKING_CARTON_LIST = `/api/booking-cartons`;
export const BOOKING_CARTON_ADD = `/api/booking-cartons/add`;
export const BOOKING_CARTON_EDIT = (id) => `/api/booking-cartons/${id}/edit`;
export const BOOKING_CARTON_UPDATE = (id) => `/api/booking-cartons/edit/${id}`;
export const BOOKING_CARTON_DELETE = (id) => `/api/booking-cartons/delete/${id}`;
export const BOOKING_CARTON_SUPPORTING_MATERIAL_ADD = (id) => `/api/booking-cartons/supporting-metarial/add/${id}`;
export const BOOKING_CARTON_UPLOAD_DOCUMENT = `/api/booking-cartons/upload-document`;
export const BOOKING_CARTON_GET_UNIQUE_SUPPLIER_PO = `/api/booking-cartons/get-unique-supplier-po`;
export const BOOKING_CARTON_GET_GARMENT_QTY = `/api/booking-cartons/get-garment-qty`;
export const BOOKING_CARTON_BUYER_DATA = `/api/booking-cartons/buyer-data`;

// Carton Inventory
export const CARTON_INVENTORY_LIST = `/api/carton-inventories`;
export const CARTON_INVENTORY_CREATE = (id) => `/api/carton-inventories/create/${id}`;
export const CARTON_INVENTORY_ADD = `/api/carton-inventories/add`;
export const CARTON_INVENTORY_EDIT = (id) => `/api/carton-inventories/${id}/edit`;
export const CARTON_INVENTORY_UPDATE = (id) => `/api/carton-inventories/edit/${id}`;
export const CARTON_INVENTORY_DELETE = (id) => `/api/carton-inventories/delete/${id}`;

export const GET_LOCAL_SUPPLIER_LISTS = `/api/local-supplier-lists`;
export const GET_SUPPLIER_INVOICE_LISTS = `/api/local-supplier-invoices`;
export const GET_SUPPLIERS_CHALLAN_LISTS = `/api/challan-list`;
export const GET_INVOICE_DETAILS = `/api/invoice-details`;
export const GET_CHALLAN_DETAILS = `/api/invoice-details`;
export const GET_ALL_LOCAL_SUPPLIERS_ALL_INVOICES = `/api/local-supplier-invoices-all`;
export const GET_HOURLY_PRODUCTION_LIST = `/api/report/all_hourly_production_list`;
export const EXPORT_HOURLY_PRODUCTION = `/api/report/export_hourly_production_report`;
export const DELETE_PRODUCTION_HOUR = `/api/report/delete_hourly_production_report`;
export const B2BLC_INVOICE_LIST = `/api/accounting/lc-invoice-list`;
export const FOC_TYPE_INVOICE_LIST = `/api/accounting/foc-invoice-list`;
export const IMPORT_VEHICLE = `/api/accounting/import-vehicle`;
export const IMPORT_VEHICLE_TYPES = `/api/accounting/import-vehicle-types`;
export const IMPORT_VEHICLE_ASSIGNMENT_VEHICLE_TYPES = `/api/accounting/import-vehicle-assignment-vehicle-types`;
export const EXPORT_SHIPMENT = `/api/accounting/export-shipment`;
export const EXPORT_SHIPMENT_LC_INVOICE_LIST = `/api/accounting/export-shipment-lc-invoice-list`;
export const EXPORT_SHIPMENT_FOC_INVOICE_LIST = `/api/accounting/export-shipment-foc-invoice-list`;
export const EXPORT_SHIPMENT_VEHICLE_TYPES = `/api/accounting/export-shipment-vehicle-types`;
export const EXPORT_VEHICLE_ASSIGNMENT = `/api/accounting/export-vehicle-assignment`;
export const EXPORT_VEHICLE_ASSIGNMENT_VEHICLE_TYPES = `/api/accounting/export-vehicle-assignment-vehicle-types`;
export const LOCAL_OUTGOING_SHIPMENT = `/api/accounting/local-outgoing-shipment`;
export const LOCAL_OUTGOING_SHIPMENT_VEHICLE_TYPES = `/api/accounting/local-outgoing-shipment-vehicle-types`;
export const LOCAL_INCOMING_SHIPMENT = `/api/accounting/local-incoming-shipment`;
export const LOCAL_INCOMING_SHIPMENT_VEHICLE_TYPES = `/api/accounting/local-incoming-shipment-vehicle-types`;
export const GARMENT_CATEGORY_LIST_ENDPOINT = `/api/garment-categories`;
export const GARMENT_CATEGORY_ADD_ENDPOINT = `/api/garment-categories/add`;
export const GARMENT_CATEGORY_EDIT_ENDPOINT = `/api/garment-categories/edit`;
export const GARMENT_CATEGORY_DELETE_ENDPOINT = `/api/garment-categories/delete`;
export const GARMENT_TYPE_LIST_ENDPOINT = `/api/garment-types`;
export const GARMENT_TYPE_ADD_ENDPOINT = `/api/garment-types/add`;
export const GARMENT_TYPE_EDIT_ENDPOINT = `/api/garment-types/edit`;
export const GARMENT_TYPE_DELETE_ENDPOINT = `/api/garment-types/delete`;
export const AIR_HOLE_TYPE_LIST_ENDPOINT = `/api/air-hole-types`;
export const AIR_HOLE_TYPE_ADD_ENDPOINT = `/api/air-hole-types/add`;
export const AIR_HOLE_TYPE_EDIT_GET_ENDPOINT = `/api/air-hole-types`; // GET /api/air-hole-types/{id}/edit
export const AIR_HOLE_TYPE_EDIT_PUT_ENDPOINT = `/api/air-hole-types/edit`;
export const AIR_HOLE_TYPE_DELETE_ENDPOINT = `/api/air-hole-types/delete`;
export const AU_FORMULA_LIST_ENDPOINT = `/api/au-formulas`;
export const AU_FORMULA_ADD_ENDPOINT = `/api/au-formulas/add`;
export const AU_FORMULA_EDIT_GET_ENDPOINT = `/api/au-formulas`; // GET /api/au-formulas/{id}/edit
export const AU_FORMULA_EDIT_PUT_ENDPOINT = `/api/au-formulas/edit`;
export const AU_FORMULA_DELETE_ENDPOINT = `/api/au-formulas/delete`;
export const CARTON_TYPE_LIST_ENDPOINT = `/api/carton-types`;
export const CARTON_TYPE_ADD_ENDPOINT = `/api/carton-types/add`;
export const CARTON_TYPE_EDIT_GET_ENDPOINT = `/api/carton-types`; // GET /api/carton-types/{id}/edit
export const CARTON_TYPE_EDIT_PUT_ENDPOINT = `/api/carton-types/edit`;
export const CARTON_TYPE_DELETE_ENDPOINT = `/api/carton-types/delete`;
export const GUSSET_TYPE_LIST_ENDPOINT = `/api/gusset-types`;
export const GUSSET_TYPE_ADD_ENDPOINT = `/api/gusset-types/add`;
export const GUSSET_TYPE_EDIT_GET_ENDPOINT = `/api/gusset-types`; // GET /api/gusset-types/{id}/edit
export const GUSSET_TYPE_EDIT_PUT_ENDPOINT = `/api/gusset-types/edit`;
export const GUSSET_TYPE_DELETE_ENDPOINT = `/api/gusset-types/delete`;
export const PLY_LIST_ENDPOINT = `/api/plies`;
export const PLY_ADD_ENDPOINT = `/api/plies/add`;
export const PLY_EDIT_GET_ENDPOINT = `/api/plies`; // GET /api/plies/{id}/edit
export const PLY_EDIT_PUT_ENDPOINT = `/api/plies/edit`;
export const PLY_DELETE_ENDPOINT = `/api/plies/delete`;
export const POLY_TYPE_LIST_ENDPOINT = `/api/poly-types`;
export const POLY_TYPE_ADD_ENDPOINT = `/api/poly-types/add`;
export const POLY_TYPE_EDIT_GET_ENDPOINT = `/api/poly-types`; // GET /api/poly-types/{id}/edit
export const POLY_TYPE_EDIT_PUT_ENDPOINT = `/api/poly-types/edit`;
export const POLY_TYPE_DELETE_ENDPOINT = `/api/poly-types/delete`;
export const SAMPLE_TYPE_LIST_ENDPOINT = `/api/sample-types`;
export const SAMPLE_TYPE_ADD_ENDPOINT = `/api/sample-types/add`;
export const SAMPLE_TYPE_EDIT_GET_ENDPOINT = `/api/sample-types`; // GET /api/sample-types/{id}/edit
export const SAMPLE_TYPE_EDIT_PUT_ENDPOINT = `/api/sample-types/edit`;
export const SAMPLE_TYPE_DELETE_ENDPOINT = `/api/sample-types/delete`;
export const MER_SAMPLE_REQUISITION_LIST = `/api/merchandising/sample-requisitions`;
export const MER_SAMPLE_REQUISITION_ADD = `/api/merchandising/sample-requisitions/add`;
export const MER_SAMPLE_REQUISITION_SHOW = (id) => `/api/merchandising/sample-requisitions/${id}`;
export const MER_SAMPLE_REQUISITION_UPDATE = (id) => `/api/merchandising/sample-requisitions/edit/${id}`;
export const MER_SAMPLE_REQUISITION_DELETE = (id) => `/api/merchandising/sample-requisitions/delete/${id}`;
export const MER_SAMPLE_REQUISITION_BUYER_DATA = `/api/merchandising/sample-requisitions/buyer-data`;
export const MER_SAMPLE_REQUISITION_STYLES = `/api/merchandising/sample-requisitions/styles`;
export const MER_SAMPLE_REQUISITION_NEXT_REFERENCE = `/api/merchandising/sample-requisitions/next-reference`;
export const MER_SAMPLE_REQUISITION_SAMPLE_TYPES = `/api/merchandising/sample-requisitions/sample-types`;
export const MER_SAMPLE_REQUISITION_UPLOAD_IMAGE = `/api/merchandising/sample-requisitions/upload-image`;
export const MER_SAMPLE_REQUISITION_DELETE_IMAGE = (id) => `/api/merchandising/sample-requisitions/delete-image/${id}`;
export const SUPPORTING_MATERIAL_TYPE_LIST_ENDPOINT = `/api/supporting-material-types`;
export const SUPPORTING_MATERIAL_TYPE_ADD_ENDPOINT = `/api/supporting-material-types/add`;
export const SUPPORTING_MATERIAL_TYPE_EDIT_GET_ENDPOINT = `/api/supporting-material-types`; // GET /api/supporting-material-types/{id}/edit
export const SUPPORTING_MATERIAL_TYPE_EDIT_PUT_ENDPOINT = `/api/supporting-material-types/edit`;
export const SUPPORTING_MATERIAL_TYPE_DELETE_ENDPOINT = `/api/supporting-material-types/delete`;
export const GARMENT_FOR_LIST_ENDPOINT = `/api/garment-for`;
export const CM_EXPENSE_HEAD_RESOURCE = `/api/accounting/cm-expense-head`;
export const CM_EXPENSE_CALCULATION_RESOURCE = `/api/accounting/cm-expense-calculation`;
export const CM_DEFAULT_DATA_RESOURCE = `/api/accounting/cm-default-data`;
export const INQUIRY_REASONS_ADD_ENDPOINT = `/api/inquiry-reasons/add`;
export const INQUIRY_REASONS_LIST_ENDPOINT = `/api/inquiry-reasons`;
export const INQUIRY_REASONS_EDIT_ENDPOINT = `/api/inquiry-reasons/edit`;
export const INQUIRY_REASONS_DELETE_ENDPOINT = `/api/inquiry-reasons/delete`;
export const INQUIRY_REMARKS_ADD_ENDPOINT = `/api/inquiry-remarks/add`;
export const INQUIRY_REMARKS_LIST_ENDPOINT = `/api/inquiry-remarks`;
export const INQUIRY_REMARKS_EDIT_ENDPOINT = `/api/inquiry-remarks/edit`;
export const INQUIRY_REMARKS_DELETE_ENDPOINT = `/api/inquiry-remarks/delete`;
export const BUYER_INQUIRY_LIST_ENDPOINT = `/api/buyer-inquiries`;
export const BUYER_INQUIRY_ADD_ENDPOINT = `/api/buyer-inquiries/add`;
export const BUYER_INQUIRY_DELETE_ENDPOINT = `/api/buyer-inquiries/delete`;
export const BUYER_INQUIRY_EDIT_ENDPOINT = `/api/buyer-inquiries/edit`;
export const BUYER_INQUIRY_VALIDATE_STYLE_NO_ENDPOINT = `/api/buyer-inquiries/validate-style-no`;
export const BUYER_INQUIRY_MULTI_STYLE_ADD_ENDPOINT = `/api/buyer-inquiries/multi-style-add`;
export const MIGRATE_BUYER_INQUIRY_ENDPOINT = `/api/migrateBuyerInquiry`;
export const CAPACITY_BOOKING_LIST_ENDPOINT = `/api/buyer-inquiries`;
export const CAPACITY_BOOKING_ADD_ENDPOINT = `/api/buyer-inquiries/add`;
export const CAPACITY_BOOKING_DELETE_ENDPOINT = `/api/buyer-inquiries/delete`;
export const CAPACITY_BOOKING_EDIT_ENDPOINT = `/api/buyer-inquiries/edit`;
export const COST_OF_MAKING_RESOURCE = `/api/accounting/cm-report`;
export const GET_TEMPLATE_BY_GARMENT = `/api/ob_tamplates/findTamplate`;
export const CM_REPORT_DATA = `/api/accounting/cm-report`;
export const SALES_CONTRACT_SIZE_ADD = `/api/sales_contract/size-store`;
export const LEARNING_CURVE_CLONE = `/api/learning-curve/clone`;
export const LEARNING_CURVE_RESOURCE = `/api/learning-curves`;
export const GET_SEWING_BY_DATE = `/api/sewing/create/by-date`;
export const GET_SELECTED_SEWING_DATA = `/api/sewing/edit`;
export const UPDATE_SEWING = `/api/sewing/edit/product`;
export const UPDATE_MANPOWER = `/api/obs/update-manpower`;
export const ITEM_CATEGORY_POSITION_FIX = `/api/itemscategories/fix-position`;
export const ALL_PERMISSIONS = `/api/permissions`;
export const PERMISSION_ADD = `/api/permissions/store`;
export const PERMISSION_EDIT = `/api/permissions/edit`;
export const PERMISSION_DELETE = `/api/permissions/delete`;
export const GET_CONVERSION_RATE = `/api/accounting/conversion-rate`;
export const BANK_NAME_ADDRESS_RESOURCE = `/api/accounting/bank-name-address`;
export const UNIT_CONVERTION = `/api/conversions/unit-conversion`;
export const GET_SALES_CONTRACT_SUPPLIERS = `/api/accounting/sales-contract-suppliers`;
export const EXPORT_DETAILS_DOC_UPLOAD = `/api/accounting/export-details/add-document`;
export const SAM_IMPORT_ENDPOINT = `/api/upload-sam`;
export const ASSIGNMENT_LINE_SUMMARY = `/api/assignment/line-assignment-summary`;
export const GET_STYLE_PO_ASSIGNMENT_SUMMARY = `/api/assignment/style-po-assignment-summary`;
export const GET_LINE_ASSIGNMENT_DETAILS = `/api/assignment/line-assignment-details`;
export const ASSIGNMENT_ADD_FORM = `/api/assignment/add-form`;
export const ASSIGNMENT_STORE = `/api/assignment/line-assignment/store`;
export const ASSIGNMENT_EDIT_VIEW = `/api/assignment/line-assignment/edit`;
export const ASSIGNMENT_UPDATE = `/api/assignment/line-assignment/update`;
export const GET_FOLDING_TABLE_ENDPOINT = `/api/folding/product/create`;
export const STORE_FOLDING_ENDPOINT = `/api/folding/product/store`;
export const GET_FOLDING_PRODUCT_ENDPOINT = `/api/folding/product/edit`;
export const FOLDING_LIST_ENDPOINT = `/api/folding`;
export const EDIT_FOLDING_PRODUCT_ENDPOINT = `/api/folding/product/update`;
export const GET_INQUIRY_NUMBER = `/api/buyer-inquiries/get-inquiry-no`;
export const BUYER_INQUIRY_GET_COUNTRIES_ENDPOINT = `/api/buyer-inquiries/get-countries`;

// Booking QTY
export const BOOKING_QTY_LIST_ENDPOINT = `/api/booking-qty`;
export const BOOKING_QTY_ADD_ENDPOINT = `/api/booking-qty/add`;
export const BOOKING_QTY_VIEW_ENDPOINT = (id) => `/api/booking-qty/${id}/edit`;
export const BOOKING_QTY_PUT_ENDPOINT = (id) => `/api/booking-qty/edit/${id}`;
export const BOOKING_QTY_DELETE_ENDPOINT = (id) => `/api/booking-qty/delete/${id}`;
export const GET_OB_INQUIRY_LIST = `/api/ob-inquiry-list`;
export const GET_OB_STYLE_LIST = `/api/ob-style-list`;
export const GET_OB_SUBSTYLE_LIST = `/api/ob-substyle-list`;
export const PACKING_CONF_LIST_ENDPOINT = `/api/packing/packing_confirmation`;
export const GET_PACKING_PRODUCT_ENDPOINT = `/api/packing/packing_confirmation/edit`;
export const UPDATE_PACKING_CONFIRMATION_ENDPOINT = `/api/packing/packing_confirmation/update`;
export const SALES_CONTRACT_SIZE_UPLOAD = `/api/upload-sales-contract-sizes`;
export const TRIMS_ACCESORY_CONSUMPTION = `/api/trims-accessories-consumption`;
export const TRIMS_ACCESSORY_STYLES_LIST = `/api/trims-accessories-styles`;
export const GET_ALL_B2BLCS = `/api/accounting/get-all-b2blcs`;
export const COURIER_OPTION_RESOURCE = `/api/accounting/courier-option`;
export const POST_TNA_PROCESS_DATA = "/api/tna-processes";
export const GET_ALL_TNA_PROCESS_DATA = "/api/tna-processes";
export const GET_SINGLE_TNA_PROCESS_DATA = "/api/tna-processes";
export const UPDATE_TNA_PROCESS_DATA = "/api/tna-processes";
export const DELETE_TNA_PROCESS_DATA = "/api/tna-processes";
export const POST_TNA_DEPARTMENT_DATA = "/api/tna-departments";
export const GET_ALL_TNA_DEPARTMENT_DATA = "/api/tna-departments";
export const GET_SINGLE_TNA_DEPARTMENT_DATA = "/api/tna-departments";
export const UPDATE_TNA_DEPARTMENT_DATA = "/api/tna-departments";
export const DELETE_TNA_DEPARTMENT_DATA = "/api/tna-departments";
export const POST_TNA_TASK_DATA = "/api/tna-tasks";
export const GET_ALL_TNA_TASK_DATA = "/api/tna-tasks";
export const GET_SINGLE_TNA_TASK_DATA = "/api/tna-tasks";
export const UPDATE_TNA_TASK_DATA = "/api/tna-tasks";
export const DELETE_TNA_TASK_DATA = "/api/tna-tasks";
export const POST_NEW_TNA_TASK_DATA = "/api/new-tna-tasks";
export const GET_ALL_NEW_TNA_TASK_DATA = "/api/new-tna-tasks";
export const GET_SINGLE_NEW_TNA_TASK_DATA = "/api/new-tna-tasks";
export const UPDATE_NEW_TNA_TASK_DATA = "/api/new-tna-tasks";
export const DELETE_NEW_TNA_TASK_DATA = "/api/new-tna-tasks";
export const TNA_TEMPLATE_BASE = `/api/tna-templates`;
export const NEW_TNA_TEMPLATE_BASE = `/api/new-tna-templates`;
export const NEW_TNA_TEMPLATE_UPDATE_DELETE_BASE = `/api/new-tna-templates`;
export const NEW_TNA_TEMPLATE_IMPORT_ENDPOINT = `/api/new-tna-templates/import`;
export const NEW_TNA_TEMPLATE_SAMPLE_DOWNLOAD_ENDPOINT = `/api/new-tna-templates/sample-download`;
export const TNA_BY_STYLE_BASE = `/api/tna-by-styles`;
export const TNA_SALES_CONTRACT = `/api/tna-plans/sales-contracts`;
export const TNA_STYLES = `/api/tna-plans/styles`;
export const TNA_POS = `/api/tna-plans/purchase-orders`;
export const TNA_TODO_ENDPOINT = `/api/tna-plans/todos`;
export const NEW_TODO_LISTS_ENDPOINT = `/api/new-todo-lists`;
export const newTodoActionStatusUpdate = (taskId) =>
  `/api/new-todo-lists/${taskId}/action-status-update`;
export const NEW_TNA_SUMMARY_DETAILS = `/api/tna-summary-details`;
export const NEW_TNA_SUMMARY_GRAPH = `/api/tna-summary-graph`;
export const GET_TNA_SUMMAARY = `/api/tna-plans/summaries`;
export const GET_TNA_SUMMAARY_DETAILS = `/api/tna-plans/summaries`;
export const GET_TNA_SUMMAARY_GRAPH = `/api/tna-plans/summaries`;
export const TNA_PLAN_BASE = `/api/tna-plans`;
export const TNA_DUE_DATE = `/api/tna-plans/due-date`;
export const TNA_PLAN_STYLES_DETAILS = `/api/tna-plans/styles`;
export const TNA_PLAN_PURCHASE_ORDER_DETAILS = `/api/tna-plans/purchase-orders`;
export const VEHICLE_SIZE_ENDPOINT = `/api/vehicle-sizes`;
export const VEHICLE_TYPE_ENDPOINT = `/api/vehicle-types`;
export const VEHICLE_DRIVER_INFOS_ENDPOINT = `/api/vehicle-driver-infos`;
export const VEHICLE_DRIVER_INFOS_ADD_ENDPOINT = `/api/vehicle-driver-infos/add`;
export const VEHICLE_DRIVER_INFOS_EDIT_ENDPOINT = `/api/vehicle-driver-infos/edit`;
export const DRIVER_VEHICLE_INFO_DELETE_ENDPOINT = `/api/vehicle-driver-infos/delete`;
export const BOLT_SEAL_LOG_LIST_ENDPOINT = `/api/bolt-seal-logs`;
export const BOLT_SEAL_LOG_ADD_ENDPOINT = `/api/bolt-seal-logs/add`;
export const BOLT_SEAL_LOG_EDIT_ENDPOINT = `/api/bolt-seal-logs/edit`;
export const BOLT_SEAL_LOG_DELETE_ENDPOINT = `/api/bolt-seal-logs/delete`;
export const EXPORT_BOLT_SEAL_LOG_REPORT_ENDPOINT = `/api/report/export_bolt_seal_log_report`;
export const GET_BOLT_SEAL_LOG_REPORT_LIST_ENDPOINT = `/api/report/all_bolt_seal_log_report_list`;
export const VIEW_BOLT_SEAL_LOG_REPORT = `/api/report/view_bolt_seal_log_report`;
export const DELETE_BOLT_SEAL_LOG_REPORT_ENDPOINT = `/api/report/delete_bolt_seal_log_report`;
export const PO_Wise_Packing_Info_ENDPOINT = `/api/po-wise-packing-info`;
export const EXPORT_DETAILS_FROMS_RESOURCES = `/api/accounting/export-details-from`;
export const SALES_CONTRACT_COMMERCIAL_FROMS_RESOURCES = `/api/accounting/sales-contract-commercial-from`;
export const PO_WISE_INFO = `/api/po_wise_purchase_orders/po-wise-info`;
export const UPLOAD_SC_COMMERCIAL_DOC_FOR_MMD = `/api/accounting/upload-sc-commercial-doc-for-mmd`;
export const SELECTED_PO_NEW_EDIT_INFO = `/api/po_wise_purchase_orders/editView`;
export const VIEW_HOURLY_PRODUCTION = `/api/report/view_hourly_production_report`;
export const VIEW_HOURLY_PRODUCTION_DETAIL_REPORT = `/api/report/view_hourly_production_detail_report`;
export const EXPORT_HOURLY_PRODUCTION_DETAIL_REPORT = `/api/report/hourly-production-detail-report-export`;
export const VIEW_PRODUCTION_DETAILS = `/api/report/view_production_details_report`;
export const VIEW_PRODUCTION_TRACKING = `/api/report/view_production_tracking_report`;
export const VIEW_FABRIC_RECONCILIATION = `/api/report/view_fabric_reconciliation_report`;
export const VIEW_SWING_VS_FOLDING = `/api/report/view_sewing_and_folding_report`;
export const VIEW_OPERATOR_ABSINTHIUM_REPORT = `/api/report/view_operator_absinthium_report`;
export const PO_MAP_NEW_ENDPOINT = `/api/packing_list/purchase_order_map_lists`;
export const TRIMS_ACCESSORIES_ITEMS_LIST = `/api/trim-accessories-inventory/items`;
export const VIEW_PRODUCTION_DETAILS_REPORT = `/api/report/view_production_details_report`;
export const VIEW_INVENTORY_DETAILS_REPORT = `/api/report/view_inventory_details_report`;
export const EXPORT_POST_COSTING_REPORT = `/api/report/export_post_costing_report`;
export const VIEW_POST_COSTING_REPORT = `/api/report/view_post_costing_report`;
export const TRIMS_ACCESSORIES_STORE = `/api/trim-accessories-inventory/store`;
export const DIGITALIZATION_CHECKLIST = `/api/digitalization/checklist`;
export const SEWING_LINES = `/api/sewing_lines`;
export const SUPERVISOR_LIST = `/api/supervisor-list`;
export const DIGITALIZATION_ABSENT_LIST = `/api/digitalization/absinthium`;
export const DIGITALIZATION_DEFECTS = `/api/digitalization/defects`;
export const GET_TRIMS_UNIQUE_TIMES = `/api/trim-accessories-inventory/get-unique-times`;
export const GET_TRIMS_ASSIGNED_ITEMS = `/api/trim-accessories-inventory/track-items-list`;
export const UPDATE_TRIMS_INVENTORY = `/api/trim-accessories-inventory/update`;
export const USER_LOGOUT = `/api/logout`;
export const UPDATE_PASSWORD = `/api/users/updatePassword`;

// DIGITALIZATION REPORTS
export const DIGITALIZATION_OPERATOR_EFFICIENCY_EXPORT_REPORT = `/api/digitalization/operator-efficiency/export-report`;
export const DIGITALIZATION_OPERATOR_WISE_HOURLY_PRODUCTION_REPORT = `/api/digitalization/report/line-wise-operator-hourly-report-generate`;
export const DIGITALIZATION_OPERATOR_WISE_HOURLY_PRODUCTION_PREVIEW = `/api/digitalization/report/line-wise-operator-hourly-report-preview`;
export const DIGITALIZATION_OPERATOR_EFFICIENCY_LIST_REPORT = `/api/digitalization/operator-efficiency/list`;
export const DIGITALIZATION_OPERATION_WISE_HOURLY_PRODUCTION_REPORT = `/api/digitalization/report/line-wise-operation-hourly-report-generate`;
export const DIGITALIZATION_OPERATION_WISE_HOURLY_PRODUCTION_PREVIEW = `/api/digitalization/report/line-wise-operation-hourly-report-preview`;

// DIGITALIZATION
export const GET_DIGITALIZATION_APP_MENUS_ROLE = `/api/digitalization/app-menus`;
export const UPDATE_DIGITALIZATION_APP_MENU_ROLE = `/api/digitalization/app-menu`;
export const GET_QA_ROLE_USERS = "/api/digitalization/qa-role-users";

// DEFECT
export const DIGITALIZATION_DEFECT_CATEGORY = `/api/digitalization/defect-category-infos`;
export const DIGITALIZATION_DEFECT_REASON = `/api/digitalization/defect-reasons`;
export const DIGITALIZATION_DEFECT_RESPONSIBLE = `/api/digitalization/defect-responsibles`;
export const DIGITALIZATION_DEFECT_RECOMMENDATION = `/api/digitalization/defect-recommendations`;
export const DIGITALIZATION_DEFECT_CATEGORY_MAPPING = `/api/digitalization/defect-category-operation-mappings`;
export const DIGITALIZATION_DEFECT_LINE_SECTION_MAPPING = `/api/digitalization/line-section-qa-mappings`;

// Production Planning Weekends
export const WEEKENDS = `/api/productionPlanning/weekend`;
export const HOLIDAYS = `/api/productionPlanning/holiday`;
export const WH_EXCEPTIONS = `/api/productionPlanning/weekend-holiday-exception`;
export const WEEKEND_HOLIDAY_LIST = `/api/productionPlanning/weekend-holiday-exception/exceptionList`;
export const PLANNING_REQUESTS = `/api/productionPlanning/planning_request`; // PlanningRequests
export const UN_PLANNING_BUYER_INQUIRY_LIST = `/api/productionPlanning/buyer_inquiry_list`; // PlanningRequests

export const GET_VEHICLE_INFOS = `/api/vehicle-infos`;
export const ADD_VEHICLE_INFOS = `/api/vehicle-infos/add`;
export const EDIT_VEHICLE_INFOS = `/api/vehicle-infos/edit`;
export const DELETE_VEHICLE_INFOS = `/api/vehicle-infos/delete`;
export const GET_DRIVER_INFOS = `/api/driver-infos`;
export const ADD_DRIVER_INFOS = `/api/driver-infos/add`;
export const EDIT_DRIVER_INFOS = `/api/driver-infos/edit`;
export const DELETE_DRIVER_INFOS = `/api/driver-infos/delete`;

export const GET_LINE_LIST = `/api/sewing_lines`;
export const GET_INQUIRY_STYLE_LIST = `/api/productionPlanning/inquiry-style-list`;
export const GET_INQUIRY_STYLE_DETAILS = `/api/productionPlanning/inquiry-style-details`;
export const TRACK_LIST_FOR_TRIMS_ADD = `/api/trim-accessories-inventory/track-items-list-for-add`;
export const GENERATE_PLANNING_DETAILS = `/api/productionPlanning/generate-planning-details`;
export const GET_SEWING_LINES = `/api/digitalization/sewing-lines`;
export const SEWING_LINE_DEFECT_REPORT = `/api/digitalization/sewing-line-defect/report`;
export const SEWING_LINE_DEFECT_MONTHLY_REPORT = `/api/digitalization/sewing-line-defect-monthly/report`;
export const GET_HOURLY_PRODUCTION_RECORDS = "/api/digitalization/hourly-production-record-lists";
export const GET_HOURLY_PRODUCTION_RECORD_DETAILS = "/api/digitalization/hourly-production-record-details";
export const GET_BUYERS = `/api/digitalization/buyers`;
export const GET_OB_INFO = `/api/digitalization/ob-info`;
export const GET_LINE_OB_INFO = `/api/digitalization/line-ob-info`;
export const DAILY_LINE_PLAN = `/api/digitalization/daily-line-plan`;
export const GET_ID_CARD_NO_USER = `/api/digitalization/id-card-no-user`;
export const REGENERATE_PLAN = `/api/productionPlanning/re-generate-planning`;
export const PLAN_INITIATE = `/api/productionPlanning/plan_initiate`;
export const PRODUCTION_PLANNING_REPORT = `/api/productionPlanning/planning-report`;
export const ImportDailyLinePlan = `/api/digitalization/import-daily-line-plan`;

export const DIGITALIZATION_CHECKLIST_QUESTION = `/api/digitalization/checklist-question`;
export const DIGITALIZATION_ROLES_CHECKLIST = `/api/digitalization/web/roles-checklists`;
export const DEFECT_CATEGORY_LISTS = `/api/digitalization/defect-category-infos`;

export const GET_APP_PRODUCTION_DETAILS = `/api/digitalization/bigscreen-dashboard/productionDetailsReport`;
export const GET_APP_OPERATOR_WISE_PERFORMANCE = `/api/digitalization/bigscreen-dashboard/operatorWisePerformanceReport`;

export const ASSIGN_LINES = `/api/digitalization/user/assign-lines`;
export const APP_USER_LIST = `/api/digitalization/app-user-list`;
export const USER_ASSIGNED_LINE_LISTS = `/api/digitalization/user-assigned-line-lists`;
export const USER_ASSIGNED_LINE = `/api/digitalization/user/assigned-line`;

export const SUB_CONTRACT_FACTORY = `/api/sub-contract-factory`;
export const GET_SALES_CONTRACT_LIST = `/api/sales_contract_list`;
export const SALES_CONTRACT_SEND_MAIL = `/api/sales_contract/send-mail`;

export const SUB_CONTRACT_AGREEMENT = `/api/sub-contract-agreement`;
export const SUBSTYLE_LIST = `/api/obs/substyles`;

export const GET_DIGITALIZATION_STYLES = `/api/digitalization/styles`;
export const GET_DIGITALIZATION_SUB_STYLES = `/api/digitalization/sub-styles`;
export const ALL_SUB_STYLES = `/api/all-sub-styles`;
export const GET_DIGITALIZATION_APP_USERS = `/api/digitalization/app-users`;

export const GET_DIGITALIZATION_SUB_STYLES_NEW_ZILANI = `/api/digitalization/subtyles`;

// OT SIGNAL
export const OT_SIGNAL_LIST_ENDPOINT = `/api/ot-signals`;
export const OT_SIGNAL_ADD_ENDPOINT = `/api/ot-signals/add`;
export const OT_SIGNAL_EDIT_ENDPOINT = `/api/ot-signals/edit`;
export const OT_SIGNAL_DELETE_ENDPOINT = `/api/ot-signals/delete`;

// OT SIGNAL SECTION
export const OT_SIGNAL_SECTION_LIST_ENDPOINT = `/api/ot-signal-sections`;
export const OT_SIGNAL_SECTION_ADD_ENDPOINT = `/api/ot-signal-sections/add`;
export const OT_SIGNAL_SECTION_EDIT_ENDPOINT = `/api/ot-signal-sections/edit`;
export const OT_SIGNAL_SECTION_DELETE_ENDPOINT = `/api/ot-signal-sections/delete`;

// PP MEETING DATE
export const PP_MEETING_DATE_LIST_ENDPOINT = `/api/pp-meeting-dates`;
export const PP_MEETING_DATE_ADD_ENDPOINT = `/api/pp-meeting-dates/add`;
export const PP_MEETING_DATE_EDIT_ENDPOINT = `/api/pp-meeting-dates/edit`;
export const PP_MEETING_DATE_DELETE_ENDPOINT = `/api/pp-meeting-dates/delete`;

// BUYER INSPECTION DATE
export const BUYER_INSPECTION_DATE_LIST_ENDPOINT = `/api/buyer-inspection-dates`;
export const BUYER_INSPECTION_DATE_ADD_ENDPOINT = `/api/buyer-inspection-dates/add`;
export const BUYER_INSPECTION_DATE_EDIT_ENDPOINT = `/api/buyer-inspection-dates/edit`;
export const BUYER_INSPECTION_DATE_DELETE_ENDPOINT = `/api/buyer-inspection-dates/delete`;

// PURPOSE
export const PURPOSE_LIST_ENDPOINT = `/api/purposes`;
export const PURPOSE_ADD_ENDPOINT = `/api/purposes/add`;
export const PURPOSE_EDIT_ENDPOINT = `/api/purposes/edit`;
export const PURPOSE_DELETE_ENDPOINT = `/api/purposes/delete`;

// AUDIT PARTY
export const AUDIT_PARTY_LIST_ENDPOINT = `/api/audit-parties`;
export const AUDIT_PARTY_ADD_ENDPOINT = `/api/audit-parties/add`;
export const AUDIT_PARTY_EDIT_ENDPOINT = `/api/audit-parties/edit`;
export const AUDIT_PARTY_DELETE_ENDPOINT = `/api/audit-parties/delete`;

// BUYER VISIT DATE
export const BUYER_VISIT_DATE_LIST_ENDPOINT = `/api/buyer-visit-dates`;
export const BUYER_VISIT_DATE_ADD_ENDPOINT = `/api/buyer-visit-dates/add`;
export const BUYER_VISIT_DATE_EDIT_ENDPOINT = `/api/buyer-visit-dates/edit`;
export const BUYER_VISIT_DATE_DELETE_ENDPOINT = `/api/buyer-visit-dates/delete`;

// CGL AUDIT
export const CGL_AUDIT_LIST_ENDPOINT = `/api/cgl-audits`;
export const CGL_AUDIT_EXPORT_REPORT_ENDPOINT = `/api/cgl-audits/export-report`;
export const CGL_AUDIT_REPORT_DETAILS_ENDPOINT = `/api/cgl-audit-report-details`;

// QC VALIDATION
export const QC_VALIDATION_LIST_ENDPOINT = `/api/qc-validations`;
export const QC_VALIDATION_EXPORT_REPORT_ENDPOINT = `/api/qc-validations/export-report`;
export const QC_VALIDATION_SHOW_ENDPOINT = `/api/qc-validations`;

// AUDIT DATE
export const AUDIT_DATE_LIST_ENDPOINT = `/api/audit-dates`;
export const AUDIT_DATE_ADD_ENDPOINT = `/api/audit-dates/add`;
export const AUDIT_DATE_EDIT_ENDPOINT = `/api/audit-dates/edit`;
export const AUDIT_DATE_DELETE_ENDPOINT = `/api/audit-dates/delete`;

// CAPACITY OF SAMPLE TEAM
export const CAPACITY_OF_SAMPLE_TEAM_LIST_ENDPOINT = `/api/capacity-of-sample-teams`;
export const CAPACITY_OF_SAMPLE_TEAM_ADD_ENDPOINT = `/api/capacity-of-sample-teams/add`;
export const CAPACITY_OF_SAMPLE_TEAM_EDIT_ENDPOINT = `/api/capacity-of-sample-teams/edit`;
export const CAPACITY_OF_SAMPLE_TEAM_DELETE_ENDPOINT = `/api/capacity-of-sample-teams/delete`;

// FABRIC LOADING CAPACITY OF STORE
export const FABRIC_LOADING_CAPACITY_OF_STORES_LIST_ENDPOINT = `/api/fabric-loading-capacity-of-stores`;
export const FABRIC_LOADING_CAPACITY_OF_STORES_ADD_ENDPOINT = `/api/fabric-loading-capacity-of-stores/add`;
export const FABRIC_LOADING_CAPACITY_OF_STORES_EDIT_ENDPOINT = `/api/fabric-loading-capacity-of-stores/edit`;
export const FABRIC_LOADING_CAPACITY_OF_STORES_DELETE_ENDPOINT = `/api/fabric-loading-capacity-of-stores/delete`;

// OVERTIME REASONS
export const OVERTIME_REASONS_LIST_ENDPOINT = `/api/overtime-reasons`;
export const OVERTIME_REASONS_ADD_ENDPOINT = `/api/overtime-reasons/add`;
export const OVERTIME_REASONS_EDIT_ENDPOINT = `/api/overtime-reasons/edit`;
export const OVERTIME_REASONS_DELETE_ENDPOINT = `/api/overtime-reasons/delete`;

// SAMPLE REQUISITION
export const SAMPLE_REQUISITIONS_LIST_ENDPOINT = `/api/sample-requisitions`;
export const SAMPLE_REQUISITIONS_ADD_ENDPOINT = `/api/sample-requisitions/add`;
export const SAMPLE_REQUISITIONS_EDIT_ENDPOINT = `/api/sample-requisitions/edit`;
export const SAMPLE_REQUISITIONS_DELETE_ENDPOINT = `/api/sample-requisitions/delete`;

// Unit Price
export const UNIT_PRICE_LIST = `/api/unit_prices`;
export const UNIT_PRICE_PO_ADD = `/api/unit_prices/add`;
export const UNIT_PRICE_PO_UPDATE = `/api/unit_prices/edit`;
export const UNIT_PRICE_DELETE = `/api/unit_prices/delete`;

// SALES CONTRACT 360
export const SALES_CONTRACT_AMENDMENTS = `/api/sales_contract_amendments`;
export const SALES_CONTRACT_STYLE_INQUIRY_DETAILS = `/api/sales_contract_style_inquiry_details`;
export const SALES_CONTRACT_ORDER_DETAILS = `/api/sales_contract_order_details`;
export const SALES_CONTRACT_PRICE = `/api/sales_contract_price`;
export const SALES_CONTRACT_OB_SUMMARY = `/api/sales_contract_ob_summary`;
export const SALES_CONTRACT_CM_SUMMARY = `/api/sales_contract_cm_summary`;
export const SALES_CONTRACT_BOOKING_PI = `/api/sales_contract_booking_pi`;
export const SALES_CONTRACT_BUDGET_VS_PI = `/api/sales_contract_budget_vs_pi`;
export const SALES_CONTRACT_BTB_RTGS_TT = `/api/sales_contract_btb_rtgs_tt`;
export const SALES_CONTRACT_IMPORT_INVOICE = `/api/sales_contract_import_invoice`;
export const SALES_CONTRACT_IMPORT_PAYMENT = `/api/sales_contract_import_payment`;
export const SALES_CONTRACT_EXPORT_INVOICE = `/api/sales_contract_export_invoice`;
export const SALES_CONTRACT_EXPORT_INVOICE_REALIZATION = `/api/sales_contract_export_invoice_realization`;
export const SALES_CONTRACT_IMPORT_NOTING_ASSESSMENT = `/api/sales_contract_import_noting_assessment`;
export const SALES_CONTRACT_TNA = `/api/sales_contract_tna`;
export const SALES_CONTRACT_BOLT_SEAL_LOGS = `/api/sales_contract_bolt_seal_logs`;
export const SALES_CONTRACT_INVENTORY = `/api/sales_contract_inventory`;
export const SALES_CONTRACT_PRODUCTION_PLAN = `/api/sales_contract_production_plan`;
export const SALES_CONTRACT_PRODUCTION_INFORMATION = `/api/sales_contract_production_information`;
export const SALES_CONTRACT_SHIPMENT_INFORMATION = `/api/sales_contract_shipment_information`;

// CAPACITY BOOKING
export const CAPACITY_BOOKINGS_LIST_ENDPOINT = `/api/capacity-bookings`;
export const CAPACITY_BOOKINGS_ADD_ENDPOINT = `/api/capacity-bookings/add`;
export const CAPACITY_BOOKINGS_EDIT_ENDPOINT = `/api/capacity-bookings/edit`;
export const CAPACITY_BOOKINGS_DELETE_ENDPOINT = `/api/capacity-bookings/delete`;

// BANK
export const BANK_LIST_ENDPOINT = `/api/banks`;
export const BANK_ADD_ENDPOINT = `/api/banks/add`;
export const BANK_EDIT_ENDPOINT = `/api/banks/edit`;
export const BANK_DELETE_ENDPOINT = `/api/banks/delete`;

// GARMENTS PARTS
export const GARMENTS_PARTS_LIST = `/api/garmentPart`;
export const GARMENTS_PARTS_ADD = `/api/garmentPart/add`;
export const GARMENTS_PARTS_EDIT = `/api/garmentPart/edit`;
export const GARMENTS_PARTS_DELETE = `/api/garmentPart/delete`;

// BRANCH
export const BRANCH_LIST_ENDPOINT = `/api/branches`;
export const BRANCH_ADD_ENDPOINT = `/api/branches/add`;
export const BRANCH_EDIT_ENDPOINT = `/api/branches/edit`;
export const BRANCH_DELETE_ENDPOINT = `/api/branches/delete`;

// ACCOUNT
export const ACCOUNT_LIST_ENDPOINT = `/api/bank_accounts`;
export const ACCOUNT_ADD_ENDPOINT = `/api/bank_accounts/add`;
export const ACCOUNT_EDIT_ENDPOINT = `/api/bank_accounts/edit`;
export const ACCOUNT_DELETE_ENDPOINT = `/api/bank_accounts/delete`;

// OSR Report
export const OSR_LIST_REPORT_ENDPOINT = `/api/report/export_osr_report`;

// STORE REQUISITION
export const STORE_REQUISITION_LIST = `/api/store-requisitions`;
export const STORE_REQUISITION_BUYER_WISE_DETAILS = `/api/store-requisitions/buyer-wise-details`;
export const STORE_REQUISITION_BOM_DETAILS = `/api/store-requisitions/get-bom-details-by-style-id`;
export const STORE_REQUISITION_STORE = `/api/store-requisitions/store`;
export const STORE_REQUISITION_UPDATE = `/api/store-requisitions/update`;
export const STORE_REQUISITION_DELETE = `/api/store-requisitions/delete`;
export const STORE_REQUISITION_APPROVE = `/api/store-requisitions/approve`;
export const STORE_REQUISITION_CHECK = `/api/store-requisitions/check`;
export const STORE_REQUISITION_ACKNOWLEDGE = `/api/store-requisitions/acknowledge`;
export const STORE_REQUISITION_GET_SR_NO = `/api/store-requisitions/get-sr-no`;
export const STORE_REQUISITION_DOWNLOAD_PDF = `/api/store-requisitions/download-pdf`;

// POST CUTTING PROCESS
export const POST_CUTTING_PROCESS_LIST = `/api/postCutting`;
export const POST_CUTTING_PROCESS_ADD = `/api/postCutting/product/store`;
export const POST_CUTTING_PROCESS_INFO = `/api/postCutting/product/create`;
export const POST_CUTTING_PROCESS_EDITINFO = `/api/postCutting/product/edit`;
export const POST_CUTTING_PROCESS_UPDATE = `/api/postCutting/product/update`;

// OVERTIME SIGNALS
export const OVERTIME_SIGNALS_LIST_ENDPOINT = `/api/overtime-signals`;
export const OVERTIME_SIGNALS_ADD_ENDPOINT = `/api/overtime-signals/add`;
export const OVERTIME_SIGNALS_EDIT_ENDPOINT = `/api/overtime-signals/edit`;
export const OVERTIME_SIGNALS_DELETE_ENDPOINT = `/api/overtime-signals/delete`;

// All Invoice List
export const INVOICES_LIST_ENDPOINT = `/api/invoice-list`;

// POST SEWING PROCESS
export const POST_SEWING_PROCESS_LIST = `/api/postSewing`;
export const POST_SEWING_PROCESS_INFO = `/api/postSewing/product/create`;
export const POST_SEWING_PROCESS_ADD = `/api/postSewing/product/store`;
export const POST_SEWING_PROCESS_EDITINFO = `/api/postSewing/product/edit`;
export const POST_SEWING_PROCESS_UPDATE = `/api/postSewing/product/update`;

// Capacity Booking Report
export const CAPACITY_BOOKING_REPORT_LIST_ENDPOINT = `/api/capacity-booking-report`;

// ERP USAGE MODULE
export const ERP_USAGE_MODULE_LIST_ENDPOINT = `/api/erp-usage/modules`;
export const ERP_USAGE_MODULE_ADD_ENDPOINT = `/api/erp-usage/modules/add`;
export const ERP_USAGE_MODULE_EDIT_ENDPOINT = `/api/erp-usage/modules/edit`;
export const ERP_USAGE_MODULE_DELETE_ENDPOINT = `/api/erp-usage/modules/delete`;

// ERP USAGE MODULE UI
export const ERP_USAGE_MODULE_UI_LIST_ENDPOINT = `/api/erp-usage/module-uis`;
export const ERP_USAGE_MODULE_UI_ADD_ENDPOINT = `/api/erp-usage/module-uis/add`;
export const ERP_USAGE_MODULE_UI_EDIT_ENDPOINT = `/api/erp-usage/module-uis/edit`;
export const ERP_USAGE_MODULE_UI_DELETE_ENDPOINT = `/api/erp-usage/module-uis/delete`;

// ERP USAGE ISSUE
export const ERP_USAGE_ISSUE_LIST_ENDPOINT = `/api/erp-usage/issues`;
export const ERP_USAGE_ISSUE_ADD_ENDPOINT = `/api/erp-usage/issues/add`;
export const ERP_USAGE_ISSUE_EDIT_ENDPOINT = `/api/erp-usage/issues/edit`;
export const ERP_USAGE_ISSUE_EDIT_ASSIGNED_TO_ME_ENDPOINT = `/api/erp-usage/issues-assigned-to-me/edit`;
export const ERP_USAGE_ISSUE_DELETE_ENDPOINT = `/api/erp-usage/issues/delete`;

export const ADD_BUYER_INQUIRY_PROCESS_MACHINE = `/api/buyer-inquiries/store-process-machine-rent`;
export const ADD_CAPACITY_BOOKING_PROCESS_MACHINE = `/api/buyer-inquiries/store-process-machine-rent`;
// ERP USAGE DASHBOARD
export const ERP_USAGE_DASHBOARD_LIST_ENDPOINT = `/api/erp-usage/dashboard`;

export const INQUIRY_REFERENCE_LIST = `/api/inquiry-references`;
export const INQUIRY_REFERENCE_ADD = `/api/inquiry-references/add`;

export const OB_TEMPLATE_IMPORT_ENDPOINT = `/api/ob-template-import`;
export const COST_SHEET_DOC_ADD = `/api/sales_contract/add-cost-sheet`;

export const BUYING_OFFICE_ADD_FROM_MODAL = `/api/buying_office/add-modal`;

// PNL REPORT
export const PNL_REPORT_OPERATOR_HR_OT_EXPENSES = `/api/pnl-report/operator-hr-ot-expenses`;
export const PNL_REPORT_LINE_WISE_TILL_TODAY_EXPENSE = `/api/pnl-report/line-wise-till-today-expense`;

// SALE CONTRACT POS
export const SALES_CONTRACT_PO_LIST = `/api/report/view_active_po_list`;

// PERMISSIONS CRUD
export const PERMISSIONS_LIST_ENDPOINT = `/api/permissions`;
export const PERMISSIONS_ADD_ENDPOINT = `/api/permissions/store`;
export const PERMISSIONS_EDIT_ENDPOINT = `/api/permissions/edit`;
export const PERMISSIONS_DELETE_ENDPOINT = `/api/permissions/delete`;

// PNL REPORT
export const PNL_REPORT_BUYER_WISE_INDIVIDUAL_PERFORMANCE = `/api/pnl-report/buyer-wise-individual-performance`;
export const OB_DELETE_ENDPOINT = `/api/ob/delete-operation`;
export const LINE_WISE_DAILY_CPM = `/api/pnl-report/line-wise-daily-cpm`;
export const LINE_WISE_TARGET_ACHIEVEMENT = `/api/pnl-report/line-wise-target-achievement`;
export const LINE_WISE_DAILY_EFFICIENCY = `/api/pnl-report/line-wise-daily-efficiency`;

// Packing Type
export const PO_TYPES = `/api/purchase_orders/poTypes`;
export const PACKING_TYPES = `/api/purchase_orders/packingTypes`;
export const BUYER_SUPPLIERS = `/api/buyer-suppliers`;
export const BUYER_SUPPLIERS_ADD = `/api/buyer-suppliers/add`;

// Export Sales Contract Tracker
export const EXPORT_SALES_CONTRACT_TRACKER = `/api/export-expense/export-sales-contract-tracker`;
// Export Invoice Tracker
export const EXPORT_INVOICE_TRACKER = `/api/export-expense/export-invoice-tracker`;
export const IMPORT_INVOICE_EXPENSE_LIST = `/api/import-expense/import-invoice-tracker`;
export const IMPORT_LC_TRACKER = `/api/import-expense/import-lc-tracker`;
export const IMPORT_EXPENSE_SALES_CONTRACT = `/api/import-expense/sales-contract`;

export const COMMERCIAL_PACKING_REQUIREMENTS = `/api/commercial_packing_requirements`;
export const COMMERCIAL_PACKING_REQUIREMENTS_EDIT = `/api/commercial_packing_requirements/edit`;

export const DIGITALIZATION_OFFLINE_APP_MODULES = `/api/digitalization/offline/app-modules`;
export const DISCARDED_DATA_LOGS = `/api/digitalization/offline/discarded-data-logs`;
export const DISCARDED_DATA_LOG_DETAILS = `/api/digitalization/offline/discarded-data-log-details`;

export const PROBLEM_REMEDY_MAP = `/api/digitalization/problem-remedy/remedy-maps`;
export const PROBLEM_REMEDY = `/api/digitalization/problem-remedy/remedies`;
export const PROBLEM_REMEDY_REASON = `/api/digitalization/problem-remedy/reasons`;
export const PROBLEM_REMEDY_PROBLEM = `/api/digitalization/problem-remedy/problems`;
export const PROBLEM_REMEDY_PROBLEM_TYPE = `/api/digitalization/problem-remedy/problem-types`;

export const STOCK_LOT_CONFIGS_LIST_ENDPOINT = "/api/stock-lot-configs";
export const STOCK_LOT_CONFIGS_ADD_ENDPOINT = "/api/stock-lot-configs/add";
export const STOCK_LOT_CONFIGS_EDIT_ENDPOINT = "/api/stock-lot-configs/edit";
export const STOCK_LOT_CONFIGS_DELETE_ENDPOINT = "/api/stock-lot-configs/delete";

// finishing line mapping
export const GET_FINISHING_LINE_MAPPING_INFO = `/api/digitalization/finishing-line-mapping-info`;
export const GET_FINISHING_LINE_MAPPINGS = `/api/digitalization/finishing-line-mappings`;
export const STORE_FINISHING_LINE_MAPPING = `/api/digitalization/finishing-line-mappings`;

// daily finishing line plan
export const GET_FINISHING_LINES = `/api/digitalization/finishing-lines`;
export const GET_DAILY_FINISHING_LINE_PLAN_SUPERVISORS = `/api/digitalization/daily-finishing-line-plan/get-supervisors`;
export const GET_DAILY_FINISHING_LINE_PLAN_OPERATORS = `/api/digitalization/daily-finishing-line-plan/get-operators`;
export const GET_PURCHASE_ORDER_MAP_LISTS = `/api/packing_list/purchase_order_map_lists`;

// vehicle information
export const VEHICLE_INFORMATION = `/api/accounting/import-vehicle-information`;

export const IMPORT_MACHINE_INFO = `/api/digitalization/machine-maintenance/machine-information/import`;

export const MACHINE_MAINTENANCE_MECHANICS = `/api/digitalization/machine-maintenance/mechanic-line-attendance/mechanics/web`;
export const GENERATE_MISMATCH_REPORT = `/api/digitalization/generate-mismatch-report`;

export const EXPORT_SALES_CONTRACT_COMMERCIAL_BANK = `/api/accounting/sales-contract-commercial-bank`;

export const UPLOAD_SC_COMMERCIAL_BANK_LOGO = `/api/accounting/upload-sc-commercial-bank-logo`;

// Exim Cost Module
export const COST_HEAD_LIST_ENDPOINT = "/api/exim-cost/cost_head";
export const COST_HEAD_ADD_ENDPOINT = "/api/exim-cost/cost_head/store";
export const COST_HEAD_EDIT_ENDPOINT = "/api/exim-cost/cost_head";
export const COST_HEAD_DELETE_ENDPOINT = "/api/exim-cost/cost_head/delete";

export const IMPORT_CNF_EXPENDITURE_LIST_ENDPOINT = "/api/exim-cost/import_cnf_expenditure";
export const IMPORT_CNF_EXPENDITURE_ADD_ENDPOINT = "/api/exim-cost/import_cnf_expenditure/store";
export const IMPORT_CNF_EXPENDITURE_EDIT_ENDPOINT = "/api/exim-cost/import_cnf_expenditure";
export const IMPORT_CNF_EXPENDITURE_DELETE_ENDPOINT = "/api/exim-cost/import_cnf_expenditure/delete";

export const EXPORT_CNF_EXPENDITURE_LIST_ENDPOINT = "/api/exim-cost/export_cnf_expenditure";
export const EXPORT_CNF_EXPENDITURE_ADD_ENDPOINT = "/api/exim-cost/export_cnf_expenditure/store";
export const EXPORT_CNF_EXPENDITURE_EDIT_ENDPOINT = "/api/exim-cost/export_cnf_expenditure";
export const EXPORT_CNF_EXPENDITURE_DELETE_ENDPOINT = "/api/exim-cost/export_cnf_expenditure/delete";

export const EXPORT_CNF_BILL_LIST_ENDPOINT = "/api/exim-cost/export_cnf_bill";
export const EXPORT_CNF_BILL_STORE_ENDPOINT = "/api/exim-cost/export_cnf_bill/store";
export const EXPORT_CNF_BILL_EDIT_ENDPOINT = "/api/exim-cost/export_cnf_bill";
export const EXPORT_CNF_BILL_NEXT_BILL_NO_ENDPOINT =
  "/api/exim-cost/export_cnf_bill/next-bill-no";
export const EXPORT_CNF_BILL_DELETE_ENDPOINT = "/api/exim-cost/export_cnf_bill/delete";

export const IMPORT_CNF_BILL_LIST_ENDPOINT = "/api/exim-cost/import_cnf_bill";
export const IMPORT_CNF_BILL_STORE_ENDPOINT = "/api/exim-cost/import_cnf_bill/store";
export const IMPORT_CNF_BILL_EDIT_ENDPOINT = "/api/exim-cost/import_cnf_bill";
export const IMPORT_CNF_BILL_NEXT_BILL_NO_ENDPOINT =
  "/api/exim-cost/import_cnf_bill/next-bill-no";
export const IMPORT_CNF_BILL_DELETE_ENDPOINT =
  "/api/exim-cost/import_cnf_bill/delete";
export const IMPORT_CNF_BILL_REQUESTED_ENDPOINT =
  "/api/exim-cost/import_cnf_bill/requested_by_user";
export const IMPORT_CNF_BILL_DISBURSE_ENDPOINT =
  "/api/exim-cost/import_cnf_bill/disburse";

export const CNF_PREPARE_BILLING_LIST_ENDPOINT = "/api/exim-cost/cnf_prepare_billing";
export const CNF_PREPARE_BILLING_NEXT_BILL_NUMBER_ENDPOINT =
  "/api/exim-cost/cnf_prepare_billing/next-bill-number";
export const CNF_PREPARE_BILLING_STORE_ENDPOINT =
  "/api/exim-cost/cnf_prepare_billing/store";
export const CNF_PREPARE_BILLING_SHOW_ENDPOINT = "/api/exim-cost/cnf_prepare_billing";
export const CNF_PREPARE_BILLING_UPDATE_ENDPOINT = "/api/exim-cost/cnf_prepare_billing";
export const CNF_PREPARE_BILLING_REQUESTED_ENDPOINT =
  "/api/exim-cost/cnf_prepare_billing/requested_by_user";
export const CNF_PREPARE_BILLING_DISBURSE_ENDPOINT =
  "/api/exim-cost/cnf_prepare_billing/disburse";

export const COST_TYPE_LIST_ENDPOINT = "/api/exim-cost/cost_type";
export const COST_TYPE_ADD_ENDPOINT = "/api/exim-cost/cost_type/store";
export const COST_TYPE_EDIT_ENDPOINT = "/api/exim-cost/cost_type";
export const COST_TYPE_DELETE_ENDPOINT = "/api/exim-cost/cost_type/delete";

export const EXIM_ACCOUNT_LIST_ENDPOINT = "/api/exim-cost/exim-account";
export const EXIM_ACCOUNT_ADD_ENDPOINT = "/api/exim-cost/exim-account/store";
export const EXIM_ACCOUNT_EDIT_ENDPOINT = "/api/exim-cost/exim-account";
export const EXIM_ACCOUNT_DELETE_ENDPOINT = "/api/exim-cost/exim-account/delete";

export const EXIM_CHARGES_LIST_ENDPOINT = "/api/exim-cost/charges";
export const EXIM_CHARGES_ADD_ENDPOINT = "/api/exim-cost/charges/store";
export const EXIM_CHARGES_EDIT_ENDPOINT = "/api/exim-cost/charges";
export const EXIM_CHARGES_DELETE_ENDPOINT = "/api/exim-cost/charges/delete";

export const LIEN_COST_LIST_ENDPOINT = "/api/exim-cost/lien-cost";
export const LIEN_COST_ADD_ENDPOINT = "/api/exim-cost/lien-cost/store";
export const LIEN_COST_EDIT_ENDPOINT = "/api/exim-cost/lien-cost";
export const LIEN_COST_DELETE_ENDPOINT = "/api/exim-cost/lien-cost/delete";

export const EB_COLLECTION_CHARGE_LIST_ENDPOINT = "/api/exim-cost/eb-collection-charges";
export const EB_COLLECTION_CHARGE_ADD_ENDPOINT = "/api/exim-cost/eb-collection-charges/store";
export const EB_COLLECTION_CHARGE_EDIT_ENDPOINT = "/api/exim-cost/eb-collection-charges";
export const EB_COLLECTION_CHARGE_DELETE_ENDPOINT = "/api/exim-cost/eb-collection-charges/delete";
export const EB_COLLECTION_CHARGE_REFERENCES_ENDPOINT =
  "/api/exim-cost/eb-collection-charges/available-references";
export const EB_COLLECTION_CHARGE_MISC_RATE_ENDPOINT =
  "/api/exim-cost/eb-collection-charges/misc-charge-rate";
export const EB_COLLECTION_CHARGE_LOOKUP_ENDPOINT =
  "/api/exim-cost/eb-collection-charges/lookup";
export const EB_COLLECTION_CHARGE_PDF_ENDPOINT =
  "/api/exim-cost/eb-collection-charges/pdf";

export const AMENDMENT_LIEN_COST_LIST_ENDPOINT = `/api/exim-cost/amendment-lien-cost`;
export const AMENDMENT_LIEN_COST_ADD_ENDPOINT = `/api/exim-cost/amendment-lien-cost/store`;
export const AMENDMENT_LIEN_COST_EDIT_ENDPOINT = `/api/exim-cost/amendment-lien-cost`;
export const AMENDMENT_LIEN_COST_DELETE_ENDPOINT = `/api/exim-cost/amendment-lien-cost/delete`;

// BGMEA UD Cost
export const BGMEA_UD_COST_LIST_ENDPOINT = "/api/exim-cost/bgmea-ud-cost";
export const BGMEA_UD_COST_ADD_ENDPOINT = "/api/exim-cost/bgmea-ud-cost/store";
export const BGMEA_UD_COST_EDIT_ENDPOINT = "/api/exim-cost/bgmea-ud-cost";
export const BGMEA_UD_COST_DELETE_ENDPOINT = "/api/exim-cost/bgmea-ud-cost/delete";

export const BGMEA_UD_AMENDMENT_LIST_ENDPOINT = "/api/exim-cost/bgmea-ud-amendment";
export const BGMEA_UD_AMENDMENT_ADD_ENDPOINT = "/api/exim-cost/bgmea-ud-amendment/store";
export const BGMEA_UD_AMENDMENT_EDIT_ENDPOINT = "/api/exim-cost/bgmea-ud-amendment";
export const BGMEA_UD_AMENDMENT_DELETE_ENDPOINT = "/api/exim-cost/bgmea-ud-amendment/delete";

export const BGMEA_UD_EXPORT_PERMISSION_COST_LIST_ENDPOINT = "/api/exim-cost/bgmea-ud-export-permission-cost";
export const BGMEA_UD_EXPORT_PERMISSION_COST_ADD_ENDPOINT = "/api/exim-cost/bgmea-ud-export-permission-cost/store";
export const BGMEA_UD_EXPORT_PERMISSION_COST_EDIT_ENDPOINT = "/api/exim-cost/bgmea-ud-export-permission-cost";
export const BGMEA_UD_EXPORT_PERMISSION_COST_DELETE_ENDPOINT = "/api/exim-cost/bgmea-ud-export-permission-cost/delete";

// B2B_LC_OPOENING_COST
export const B2B_LC_OPENING_COST_LIST_ENDPOINT = "/api/exim-cost/b2b-lc-opening-cost";
export const B2B_LC_OPENING_COST_ADD_ENDPOINT = "/api/exim-cost/b2b-lc-opening-cost/store";
export const B2B_LC_OPENING_COST_EDIT_ENDPOINT = "/api/exim-cost/b2b-lc-opening-cost";
export const B2B_LC_OPENING_COST_DELETE_ENDPOINT = "/api/exim-cost/b2b-lc-opening-cost/delete";

// B2B_LC_AMENDMENT_OPENING_COST
export const B2B_LC_AMENDMENT_OPENING_COST_LIST_ENDPOINT = "/api/exim-cost/b2b-lc-amendment-opening-cost";
export const B2B_LC_AMENDMENT_OPENING_COST_ADD_ENDPOINT = "/api/exim-cost/b2b-lc-amendment-opening-cost/store";
export const B2B_LC_AMENDMENT_OPENING_COST_EDIT_ENDPOINT = "/api/exim-cost/b2b-lc-amendment-opening-cost";
export const B2B_LC_AMENDMENT_OPENING_COST_DELETE_ENDPOINT = "/api/exim-cost/b2b-lc-amendment-opening-cost/delete";

// B2B_LC_SHIPPING_GUARANTEE_COST
export const B2B_LC_SHIPPING_GUARANTEE_COST_LIST_ENDPOINT = "/api/exim-cost/b2b-lc-shipping-guarantee-cost";
export const B2B_LC_SHIPPING_GUARANTEE_COST_ADD_ENDPOINT = "/api/exim-cost/b2b-lc-shipping-guarantee-cost/store";
export const B2B_LC_SHIPPING_GUARANTEE_COST_EDIT_ENDPOINT = "/api/exim-cost/b2b-lc-shipping-guarantee-cost";
export const B2B_LC_SHIPPING_GUARANTEE_COST_DELETE_ENDPOINT = "/api/exim-cost/b2b-lc-shipping-guarantee-cost/delete";

// B2B_LC_ACCEPTANCE_COMMISSION
export const B2B_LC_ACCEPTANCE_COMMISSION_LIST_ENDPOINT = "/api/exim-cost/b2b-lc-acceptance-commission";
export const B2B_LC_ACCEPTANCE_COMMISSION_ADD_ENDPOINT = "/api/exim-cost/b2b-lc-acceptance-commission/store";
export const B2B_LC_ACCEPTANCE_COMMISSION_EDIT_ENDPOINT = "/api/exim-cost/b2b-lc-acceptance-commission";
export const B2B_LC_ACCEPTANCE_COMMISSION_DELETE_ENDPOINT = "/api/exim-cost/b2b-lc-acceptance-commission/delete";
export const EXIM_GET_BANK_REF_NO_ENDPOINT = "/api/exim-cost/get_bank_ref_no";

// IOU COST
export const IOU_COST_LIST_ENDPOINT = "/api/exim-cost/iou_cost";
export const IOU_COST_EXCEL_ENDPOINT = "/api/exim-cost/iou_cost/export-excel";
export const IOU_COST_TAKEN_BY_USERS_ENDPOINT = "/api/exim-cost/iou_cost/taken_by_users";
export const IOU_COST_ADD_ENDPOINT = "/api/exim-cost/iou_cost/store";
export const IOU_COST_EDIT_ENDPOINT = "/api/exim-cost/iou_cost";
export const IOU_COST_DELETE_ENDPOINT = "/api/exim-cost/iou_cost/delete";

export const IMPORT_B2BLCS_RESOURCE_ENDPOINT = `/api/accounting/import-b2blcs`;

export const IMPORT_B2BLC_INSURANCE_COMPANY_RESOURCE_ENDPOINT = `/api/accounting/import-b2blc-insurance-company`;

export const GET_DAILY_FINISHING_LINE_PLAN_STYLES = `/api/digitalization/daily-finishing-line-plan-styles`;

export const DAILY_LINE_PLAN_LIST_COPY = `/api/digitalization/daily-finishing-line-plan-copy`;
// Document Fee
export const EXPORT_DOC_FEE_LIST_ENDPOINT = "/api/exim-cost/export_doc_fee";
export const EXPORT_DOC_FEE_ADD_ENDPOINT = "/api/exim-cost/export_doc_fee/store";
export const EXPORT_DOC_FEE_EDIT_ENDPOINT = "/api/exim-cost/export_doc_fee";
export const EXPORT_DOC_FEE_DELETE_ENDPOINT = "/api/exim-cost/export_doc_fee/delete";

// Certificate Of Origin Fee
export const CERTIFICATE_OF_ORIGIN_FEE_LIST_ENDPOINT = "/api/exim-cost/certificate_origin_fee";
export const CERTIFICATE_OF_ORIGIN_FEE_ADD_ENDPOINT = "/api/exim-cost/certificate_origin_fee/store";
export const CERTIFICATE_OF_ORIGIN_FEE_EDIT_ENDPOINT = "/api/exim-cost/certificate_origin_fee";
export const CERTIFICATE_OF_ORIGIN_FEE_DELETE_ENDPOINT = "/api/exim-cost/certificate_origin_fee/delete";

// EPB Type
export const EPB_TYPE_LIST_ENDPOINT = "/api/exim-cost/epb_type";
export const EPB_TYPE_ADD_ENDPOINT = "/api/exim-cost/epb_type/store";
export const EPB_TYPE_EDIT_ENDPOINT = "/api/exim-cost/epb_type";
export const EPB_TYPE_DELETE_ENDPOINT = "/api/exim-cost/epb_type/delete";

// EPB Attribute
export const EPB_ATTRIBUTE_LIST_ENDPOINT = "/api/exim-cost/epb_attribute";
export const EPB_ATTRIBUTE_ADD_ENDPOINT = "/api/exim-cost/epb_attribute/store";
export const EPB_ATTRIBUTE_EDIT_ENDPOINT = "/api/exim-cost/epb_attribute";
export const EPB_ATTRIBUTE_DELETE_ENDPOINT = "/api/exim-cost/epb_attribute/delete";

// Import Bill Retirement
export const IMPORT_BILL_RETIREMENT_LIST_ENDPOINT = "/api/exim-cost/import_bill_retirement";
export const IMPORT_BILL_RETIREMENT_ADD_ENDPOINT = "/api/exim-cost/import_bill_retirement/store";
export const IMPORT_BILL_RETIREMENT_EDIT_ENDPOINT = "/api/exim-cost/import_bill_retirement";
export const IMPORT_BILL_RETIREMENT_DELETE_ENDPOINT = "/api/exim-cost/import_bill_retirement/delete";

// Marine Cover Note Bill
export const MARINA_COVER_NOTE_BILL_LIST_ENDPOINT = "/api/exim-cost/marine_cover_note";
export const MARINA_COVER_NOTE_BILL_ADD_ENDPOINT = "/api/exim-cost/marine_cover_note/store";
export const MARINA_COVER_NOTE_BILL_EDIT_ENDPOINT = "/api/exim-cost/marine_cover_note";
export const MARINA_COVER_NOTE_BILL_DELETE_ENDPOINT = "/api/exim-cost/marine_cover_note/delete";
export const MARINA_COVER_NOTE_BILL_INFO_ENDPOINT = "/api/exim-cost/marine_cover_note_info";
export const MARINA_INSURANCE_COMPANIES_ENDPOINT = "/api/exim-cost/marina_insurance_companies";

export const PI_DETAILS = `/api/accounting/import-pi/show`;
export const UPLOAD_FOC_BOM = `/api/upload-foc-bom`;

export const FOLDING_REQUIREMENT_LIST = `/api/digitalization/folding-requirement-list`;
export const FOLDING_REQUIREMENT_VIEW = `/api/digitalization/folding-requirement-view`;
export const FOLDING_REQUIREMENT_ADD = `/api/digitalization/folding-requirement-store`;
export const FOLDING_REQUIREMENT_UPDATE = `/api/digitalization/folding-requirement-update`;
export const FOLDING_REQUIREMENT_DELETE = `/api/digitalization/folding-requirement-delete`;
export const FOLDING_REQUIREMENT_STYLE_LISTS = `/api/digitalization/folding-requirement-style-lists`;
export const PACKING_REPORT_TEMPLATE_PRE_REQUISITES = `/api/packing-report-template/pre-requisites`;
export const PACKING_REPORT_TEMPLATE_LIST = `/api/packing-report-template`;
export const PACKING_REPORT_TEMPLATE_STORE = `/api/packing-report-template/store`;
export const PACKING_REPORT_TEMPLATE_VIEW = `/api/packing-report-template`;
export const PACKING_REPORT_TEMPLATE_VARIABLE_DATA = `/api/packing-report-template/variable-data`;
export const PACKING_REPORT_TEMPLATE_UPDATE = `/api/packing-report-template/update`;
export const PACKING_REPORT_TEMPLATE_EXPORT = `/api/packing-report-template/export`;
export const IOU_COST_CREATE_ENDPOINT = `/api/exim-cost/iou_cost/create`;
export const IOU_PURPOSE_LIST_ENDPOINT = `/api/exim-cost/iou_purpose`;
export const IOU_COST_STORE_ENDPOINT = `/api/exim-cost/iou_purpose/store`;
export const IOU_REQUESTED_BY_USER_ENDPOINT = `/api/exim-cost/iou_costs/requested_by_user`;
export const IOU_DISBURSE_ENDPOINT = `/api/exim-cost/iou_costs/disburse`;
export const IOU_COST_PDF_ENDPOINT = `/api/exim-cost/iou_cost/pdf`;
export const IOU_DOCUMENT_GET_ENDPOINT = `/api/exim-cost/iou_document`;

export const SUPPLIER_WISE_ITEM_PRICE_REPORT = `/api/report/supplier_wise_item_price_report`;
export const SALES_CONTRACT_COST_REPORT = `/api/report/salesContractCostReport`;

export const SIZE_QTY_UPLOAD_ENDPOINT = `/api/qty-breakdown/size-qty-upload`;

export const UPLOAD_BOM_ITEMS = `/api/bill_of_material/upload-bom-items`;
export const IMPORT_B2BLC_EXPORT_INVOICES = `/api/accounting/import-b2blc/export-invoices`;

export const IOU_DOCUMENTS_LIST = `/api/exim-cost/afterDisburseIOUList`;

export const IOU_WISE_DOCUMENT = `/api/exim-cost/iou_wise_document`;
export const IOU_ADJUSTMENT_IMPORT_STORE_ENDPOINT = `/api/exim-cost/iou_adjustment_import/store`;
export const IOU_ADJUSTMENT_IMPORT_EDIT_ENDPOINT = `/api/exim-cost/iou_adjustment_import`;

export const IOU_DOCUMENTS_REQUESTED_BY_USER = `/api/exim-cost/iou_documents/requested_doc_by_user`;

export const IOU_ATTACHMENT_UPLOAD = `/api/exim-cost/iou_files/attachments`;

export const MARINA_COVER_NOTE_BILL_PDF_ENDPOINT = `/api/exim-cost/marine_cover_note/pdf`;

export const UNIT_PRICES_ROW_EDIT_ENDPOINT = `/api/unit_prices/row-edit`;

export const IOU_EXPORT_RA_EXPENDITURE = "/api/exim-cost/iou_export_ra_expenditure";
export const IOU_EXPORT_RA_EXPENDITURE_STORE = "/api/exim-cost/iou_export_ra_expenditure/store";
export const IOU_EXPORT_RA_EXPENDITURE_DELETE = "/api/exim-cost/iou_export_ra_expenditure/delete";

export const IOU_EXPORT_NRA_EXPENDITURE = "/api/exim-cost/iou_export_nra_expenditure";
export const IOU_EXPORT_NRA_EXPENDITURE_STORE = "/api/exim-cost/iou_export_nra_expenditure/store";
export const IOU_EXPORT_NRA_EXPENDITURE_DELETE = "/api/exim-cost/iou_export_nra_expenditure/delete";

export const IOU_IMPORT_RA_EXPENDITURE = "/api/exim-cost/iou_import_ra_expenditure";
export const IOU_IMPORT_RA_EXPENDITURE_STORE = "/api/exim-cost/iou_import_ra_expenditure/store";
export const IOU_IMPORT_RA_EXPENDITURE_DELETE = "/api/exim-cost/iou_import_ra_expenditure/delete";

export const IOU_IMPORT_NRA_EXPENDITURE = "/api/exim-cost/iou_import_nra_expenditure";
export const IOU_IMPORT_NRA_EXPENDITURE_STORE = "/api/exim-cost/iou_import_nra_expenditure/store";
export const IOU_IMPORT_NRA_EXPENDITURE_DELETE = "/api/exim-cost/iou_import_nra_expenditure/delete";

export const IOU_ADJUSTMENT_LIST = "/api/exim-cost/iou_adjustment";

export const IOU_ADJUSTMENT_STORE = `/api/exim-cost/iou_adjustment/store`;
export const IOU_ADJUSTMENT_PDF_ENDPOINT = `/api/exim-cost/iou_adjustment/pdf`;
export const IOU_ADJUSTMENT_REQUESTED_BY_USER_ENDPOINT = `/api/exim-cost/iou_adjustment/requested_by_user`;

export const IOU_GENERAL_RA_EXPENDITURE = "/api/exim-cost/iou_general_ra_expenditure";
export const IOU_GENERAL_RA_EXPENDITURE_STORE = "/api/exim-cost/iou_general_ra_expenditure/store";
export const IOU_GENERAL_RA_EXPENDITURE_DELETE = "/api/exim-cost/iou_general_ra_expenditure/delete";

export const IOU_GENERAL_NRA_EXPENDITURE = "/api/exim-cost/iou_general_nra_expenditure";
export const IOU_GENERAL_NRA_EXPENDITURE_STORE = "/api/exim-cost/iou_general_nra_expenditure/store";
export const IOU_GENERAL_NRA_EXPENDITURE_DELETE = "/api/exim-cost/iou_general_nra_expenditure/delete";

export const IOU_ADJUSTMENT_GENERAL_LIST = "/api/exim-cost/iou_adjustment_general";
export const IOU_ADJUSTMENT_GENERAL_STORE = `/api/exim-cost/iou_adjustment_general/store`;
export const IOU_ADJUSTMENT_GENERAL_PDF = `/api/exim-cost/iou_adjustment_general/pdf`;
export const IOU_ADJUSTMENT_GENERAL_REQUESTED_BY_USER = `/api/exim-cost/iou_adjustment_general/requested_by_user`;
export const UNIT_PRICES_ROW_UPDATE_ENDPOINT = `/api/unit_prices/row-update`;

export const PACKING_LINES_ENDPOINT = `/api/packing_lines`;
export const PACKING_LINES_ADD_ENDPOINT = `/api/packing_lines/add`;
export const PACKING_LINES_EDIT_ENDPOINT = `/api/packing_lines/edit`;
export const PACKING_LINES_DELETE_ENDPOINT = `/api/packing_lines/delete`;

export const PACKING_TABLE_ENDPOINT = `/api/packing_tables`;
export const PACKING_TABLE_ADD_ENDPOINT = `/api/packing_tables/add`;
export const PACKING_TABLE_EDIT_ENDPOINT = `/api/packing_tables/edit`;
export const PACKING_TABLE_DELETE_ENDPOINT = `/api/packing_tables/delete`;

export const PACKING_OPERATOR_MAPPING_ENDPOINT = `/api/packing_operator_mappings`;
export const PACKING_OPERATOR_MAPPING_ADD_ENDPOINT = `/api/packing_operator_mappings/add`;
export const PACKING_OPERATOR_MAPPING_EDIT_ENDPOINT = `/api/packing_operator_mappings/edit`;
export const PACKING_OPERATOR_MAPPING_DELETE_ENDPOINT = `/api/packing_operator_mappings/delete`;

export const LINE_WISE_OPERATIONS_ENDPOINT = `/api/digitalization/line-wise-operations`;
export const ASSIGNED_OPERATORS_ENDPOINT = `/api/digitalization/assigned-operators`;

export const HOURLY_PACKING_LIST_ENDPOINT = `/api/digitalization/hourly-packing/index`;
export const HOURLY_PACKING_EDIT_ENDPOINT = `/api/digitalization/hourly-packing/edit`;
export const HOURLY_PACKING_UPDATE_ENDPOINT = `/api/digitalization/hourly-packing/update`;

export const DAILY_PACKING_ASSIGNMENT_LIST_ENDPOINT = `/api/digitalization/packing-assignment/get-all-packing-assignments`;
export const DAILY_PACKING_ASSIGNMENT_POS_ENDPOINT = `/api/digitalization/packing-assignment/get-pos`;
export const DAILY_PACKING_ASSIGNMENT_LINE_TABLE_ENDPOINT = `/api/digitalization/packing-assignment/get-line-and-table`;
export const DAILY_PACKING_ASSIGNMENT_SPECIFIC_MAPPING_ENDPOINT = `/api/digitalization/packing-assignment/get-specific-mapping`;
export const DAILY_PACKING_ASSIGNMENT_STORE_ENDPOINT = `/api/digitalization/packing-assignment/store`;
export const DAILY_PACKING_ASSIGNMENT_EDIT_ENDPOINT = `/api/digitalization/packing-assignment/edit`;
export const DAILY_PACKING_ASSIGNMENT_UPDATE_ENDPOINT = `/api/digitalization/packing-assignment/update`;
export const DAILY_PACKING_ASSIGNMENT_DELETE_ENDPOINT = `/api/digitalization/packing-assignment/delete`;

export const HOURLY_TARGET_SETUP_GARMENTS_TRACKING_LIST = `/api/digitalization/hourly-target-setup-garments-tracking`;
export const HOURLY_TARGET_SETUP_GARMENTS_TRACKING_GET = `/api/digitalization/hourly-target-setup-garments-tracking`;
export const HOURLY_TARGET_SETUP_GARMENTS_TRACKING_ADD = `/api/digitalization/hourly-target-setup-garments-tracking`;
export const HOURLY_TARGET_SETUP_GARMENTS_TRACKING_EDIT = `/api/digitalization/hourly-target-setup-garments-tracking`;
export const HOURLY_TARGET_SETUP_GARMENTS_TRACKING_DELETE = `/api/digitalization/hourly-target-setup-garments-tracking`;
export const HOURLY_TARGET_SETUP_GARMENTS_TRACKING_BULK_UPLOAD = `/api/digitalization/garments-tracking-hourly-target-bulk-upload`;
export const GET_QUALITY_INSPECTOR_LIST = `/api/digitalization/get-quality-inspector-list`;

export const AFTER_DISBURSE_IOU_LIST = "/api/exim-cost/afterDisburseIOUList";

// Carton Booking Configuration Endpoints
export const CARTON_WAREHOUSE_LIST_ENDPOINT = `/api/carton-warehouses`;
export const CARTON_WAREHOUSE_ADD_ENDPOINT = `/api/carton-warehouses/add`;
export const CARTON_WAREHOUSE_EDIT_ENDPOINT = `/api/carton-warehouses/edit`;
export const CARTON_WAREHOUSE_DELETE_ENDPOINT = `/api/carton-warehouses/delete`;

export const CARTON_FLOOR_LIST_ENDPOINT = `/api/carton-floors`;
export const CARTON_FLOOR_ADD_ENDPOINT = `/api/carton-floors/add`;
export const CARTON_FLOOR_EDIT_ENDPOINT = `/api/carton-floors/edit`;
export const CARTON_FLOOR_DELETE_ENDPOINT = `/api/carton-floors/delete`;
export const CARTON_FLOOR_SHOW_FLOOR_ENDPOINT = `/api/carton-floors/show-floor`;

export const CARTON_PARTITION_LIST_ENDPOINT = `/api/carton-partitions`;
export const CARTON_PARTITION_ADD_ENDPOINT = `/api/carton-partitions/add`;
export const CARTON_PARTITION_EDIT_ENDPOINT = `/api/carton-partitions/edit`;
export const CARTON_PARTITION_DELETE_ENDPOINT = `/api/carton-partitions/delete`;
export const CARTON_PARTITION_SHOW_PARTITION_ENDPOINT = `/api/carton-partitions/show-partition`;

// Fabric Defect Category Configuration Endpoints
export const FABRIC_DEFECT_CATEGORY_LIST_ENDPOINT = `/api/fabric-defect-categories`;
export const FABRIC_DEFECT_CATEGORY_ADD_ENDPOINT = `/api/fabric-defect-categories/add`;
export const FABRIC_DEFECT_CATEGORY_EDIT_ENDPOINT = `/api/fabric-defect-categories/edit`;
export const FABRIC_DEFECT_CATEGORY_DELETE_ENDPOINT = `/api/fabric-defect-categories/delete`;
export const FABRIC_DEFECT_CATEGORY_ACTIVE_ENDPOINT = `/api/fabric-defect-categories-active`;

// Fabric Inspection Endpoints
export const FABRIC_INSPECTION_LIST_ENDPOINT = `/api/fabric-inspections`;
export const FABRIC_INSPECTION_EXPORT_ENDPOINT = `/api/fabric-inspections/export`;
export const FABRIC_INSPECTION_SHOW_ENDPOINT = `/api/fabric-inspections`;
export const FABRIC_INSPECTION_ADD_ENDPOINT = `/api/fabric-inspections/store`;
export const FABRIC_INSPECTION_EDIT_ENDPOINT = `/api/fabric-inspections/edit`;
export const FABRIC_INSPECTION_DELETE_ENDPOINT = `/api/fabric-inspections/delete`;
export const FABRIC_INSPECTION_STYLES_ENDPOINT = `/api/fabric-inspections-styles`;
export const FABRIC_INSPECTION_INVENTORY_DETAILS_ENDPOINT = `/api/fabric-inspections-inventory-details`;

// Final Product Inspection
export const FINAL_INSPECTION_EXPORT_ENDPOINT = `/api/final-product-inspections/export`;
export const FINAL_INSPECTION_LIST_ENDPOINT = `/api/final-product-inspections`;
export const FINAL_INSPECTION_SHOW_ENDPOINT = `/api/final-product-inspections`;
export const FINAL_INSPECTION_ADD_ENDPOINT = `/api/final-product-inspections/store`;
export const FINAL_INSPECTION_EDIT_ENDPOINT = `/api/final-product-inspections/edit`;
export const FINAL_INSPECTION_DELETE_ENDPOINT = `/api/final-product-inspections/delete`;
export const FINAL_INSPECTION_STYLES_ENDPOINT = `/api/final-product-inspections-styles`;
export const FINAL_INSPECTION_ORDER_QTY_ENDPOINT = `/api/final-product-inspections-details`;
export const FINAL_INSPECTION_TYPES_ENDPOINT = `/api/final-product-inspection-types`;
export const FINAL_INSPECTION_LEAD_BYS_ENDPOINT = `/api/final-product-inspection-lead-bys`;
// Transportation Cost
export const TRANSPORT_PARTICULAR_LIST_ENDPOINT = "/api/transportation-cost/particulars";
export const TRANSPORT_PARTICULAR_OPTIONS_ENDPOINT = "/api/transportation-cost/particulars/options";
export const TRANSPORT_PARTICULAR_ADD_ENDPOINT = "/api/transportation-cost/particulars/store";
export const TRANSPORT_PARTICULAR_EDIT_ENDPOINT = "/api/transportation-cost/particulars";
export const TRANSPORT_PARTICULAR_DELETE_ENDPOINT = "/api/transportation-cost/particulars/delete";
export const TRANSPORT_CHARGE_TYPE_LIST_ENDPOINT = "/api/transportation-cost/charge-types";
export const TRANSPORT_CHARGE_TYPE_OPTIONS_ENDPOINT = "/api/transportation-cost/charge-types/options";
export const TRANSPORT_CHARGE_TYPE_ADD_ENDPOINT = "/api/transportation-cost/charge-types/store";
export const TRANSPORT_CHARGE_TYPE_EDIT_ENDPOINT = "/api/transportation-cost/charge-types";
export const TRANSPORT_CHARGE_TYPE_DELETE_ENDPOINT = "/api/transportation-cost/charge-types/delete";
export const TRANSPORTATION_COST_LIST_ENDPOINT = "/api/transportation-cost/entries";
export const TRANSPORTATION_COST_REFERENCE_OPTIONS_ENDPOINT = "/api/transportation-cost/entries/reference-options";
export const TRANSPORTATION_COST_ADD_ENDPOINT = "/api/transportation-cost/entries/store";
export const TRANSPORTATION_COST_EDIT_ENDPOINT = "/api/transportation-cost/entries";
export const TRANSPORTATION_COST_DELETE_ENDPOINT = "/api/transportation-cost/entries/delete";
export const TRANSPORTATION_COST_PDF_ENDPOINT = "/api/transportation-cost/entries/pdf";

